<template>
  <div>
    <div class="heading-box">
      <div class="main-heading" v-if="existingConsentData.opType === 'toEdit'">Editing "{{ existingConsentData.consentName }}"</div>
      <div v-if="existingConsentData.opType === 'toAdd'">
        <div class="main-heading">Create a consent or agreement</div>
        <div class="sub-heading">
          A consent or agreement consists of: education, comprehension, and document with signature.
        </div>
      </div>
      <div v-if="existingConsentData.opType==='toOptionalEdit'">  
        <div class="main-heading">Create a consent or agreement</div>
     <div
       class="sub-heading"
     >A consent or agreement consists of: education, comprehension, and document with signature.</div>
     
    
   </div> 
    </div>
    <div class="child-container">
      <!--Box 1-->
      <div class="box">
        <div class="box-heading" @click="innerBoxes.box1 = !innerBoxes.box1" v-bind:class="{ active: innerBoxes.box1 }">
          <img v-if="innerBoxes.box1" src="/static/img/econsent/collapse.svg" />
          <img v-if="!innerBoxes.box1" src="/static/img/econsent/expand.svg" />
          <span>Consent Name</span>
        </div>
        <b-collapse v-model="innerBoxes.box1" :id="innerBoxes.id1">
          <div class="inner-box">
            <input
              type="text"
              @input="resetAutoSave"
              class="input-field"
              v-if="existingConsentData.opType === 'toEdit'"
              v-model.trim="existingConsentData.consentName"
              @change="tempChangeConsentName"
              v-validate="'required'"
              name="consent_name"
              :class="{
                input: true,
                'is-danger': errors.has('consent_name'),
                'is-success': !errors.has('consent_name')
              }"
            />
            <span v-show="errors.has('consent_name')" class="error-style pl-8">Please enter Consent Name</span>
            <input type="text" @input="resetAutoSave" class="input-field form-group" v-if="existingConsentData.opType === 'toAdd'" v-model.trim="newConsentName" />
            <input
            type="text"
            class="input-field form-group"
            v-if="existingConsentData.opType==='toOptionalEdit'"
            value="Datavant Tokenization Consent"
            disabled
            >
            <button class="continue-btn1" v-if="existingConsentData.opType === 'toEdit'" @click="nextChangeConsentName()">
              Continue
            </button>

            <button class="continue-btn1" v-if="existingConsentData.opType === 'toAdd'" @click="addConsent()">
              Continue
            </button>
            <button
            class="continue-btn1"
            v-if="existingConsentData.opType==='toOptionalEdit'"
            @click="optionalEditConsent()"
           >Continue</button>
          </div>
        </b-collapse>
      </div>
      <!--Box 1 End-->
      <div class="box-divider"></div>

      <!--Box 2-->
      <div class="box" :class="{ 'disable-consent': !flagData.educationEnabled }">
        <div class="d-flex">
          <div
            class="box-heading mr-auto"
            @click="box2toggle()"
            v-bind:class="{
              active: innerBoxes.box2,
              'disabled-icon': !flagData.educationEnabled
            }"
          >
            <img v-if="innerBoxes.box2" src="/static/img/econsent/collapse.svg" />
            <img v-if="!innerBoxes.box2" src="/static/img/econsent/expand.svg" />
            <span>Education</span>
          </div>
          <div class="on-off">
            <div class="t-switch off"><label>Off</label></div>
            <div class="t-switch">
              <label class="switch">
                <input type="checkbox" v-model="flagData.educationEnabled" @change="onChangeFlag(flagData.educationEnabled, 'educationEnabled')" />
                <div class="slider round"></div>
              </label>
            </div>
            <div class="t-switch on"><label>On</label></div>
          </div>
        </div>
        <b-collapse v-model="innerBoxes.box2" :id="innerBoxes.id2">
          <div class="inner-box">
            <div class="box2-content">
              These topics will be presented to your participants as a series of screens that your participants will be required to read. You may add, modify, or rearrange as you see fit.
            </div>
            {{ consentSections.consentId }}
            <draggable v-if="existingConsentData.opType === 'toEdit'" v-model="consentSections" :options="{ disabled: draggableSection }" @start="drag = true" @end="drag = false" @change="onDragSections(consentId)">
              <div v-for="(section, index) in consentSections" v-bind:key="index">
                <div class="box2-draggable-education" v-if="selectedConsentSection.sectionId !== section.sectionId">
                  <span>
                    <img src="static/img/drag.svg" class="cursor_pointer" />
                  </span>
                  <div class="content">
                    <div class="heading">{{ section.sectionTitle }}</div>
                    <div class="text">{{ section.sectionSummary }}</div>
                  </div>
                  <div class="btn">
                    <button v-on:click="editConsentSection(section)">
                      Edit
                    </button>
                  </div>

                  <div class="clearfix"></div>
                </div>

                <div class="row mt-20" v-if="selectedConsentSection.opType === 'toEdit' && selectedConsentSection.sectionId === section.sectionId">
                  <addEditEducation :options="selectedConsentSection" :eConsentData="options" @newAddedVideoData="addVideoData" @autoSaveReset="resetAutoSave"></addEditEducation>
                </div>
              </div>
            </draggable>

            <draggable v-if="existingConsentData.opType === 'toAdd'" v-model="consentSections" :options="{ disabled: draggableSection }" @start="drag = true" @end="drag = false" @change="onDragSections(consentId)">
              <div v-for="(section, index) in consentSections" v-bind:key="index">
                <div class="box2-draggable-education" v-if="selectedConsentSection.sectionId !== section.sectionId">
                  <span>
                    <img src="static/img/drag.svg" class="cursor_pointer" />
                  </span>
                  <div class="content">
                    <div class="heading">{{ section.sectionTitle }}</div>
                    <div class="text">{{ section.sectionSummary }}</div>
                  </div>
                  <div class="btn">
                    <button v-on:click="editConsentSection(section)">
                      Edit
                    </button>
                  </div>

                  <div class="clearfix"></div>
                </div>
                <div class="row mt-20" v-if="selectedConsentSection.opType === 'toEdit' && selectedConsentSection.sectionId === section.sectionId">
                  <addEditEducation :options="selectedConsentSection" :eConsentData="options" @newAddedVideoData="addVideoData" @autoSaveReset="resetAutoSave"></addEditEducation>
                </div>
              </div>
            </draggable>
            <draggable
            v-if="existingConsentData.opType === 'toOptionalEdit'"
            v-model="consentSections"
            :options="{ disabled: true }"
          > 
           <div v-for="(section, index) in consentSections" v-bind:key="index">           
               <div
                class="box2-draggable-education"
                v-if="selectedConsentSection.sectionId !== section.sectionId"
              >
                <span>
                  <img src="static/img/drag.svg" class="cursor_pointer">
                </span>
                <div class="content">
                  <div class="heading">{{ section.sectionTitle }}</div>
                  <div class="text">{{ section.sectionSummary }}</div>
                </div>
                <div class="btn">
                  <button v-on:click="editOptionalConsentSection(section)">Edit</button>
                 </div> 
                <div class="clearfix"></div>
              </div>
              <div
                class="row mt-20"
                v-if="selectedConsentSection.opType === 'toEdit' && selectedConsentSection.sectionId === section.sectionId"
              >
                <addEditEducation :options="selectedConsentSection"  :existingConsent="existingConsents" :eConsentData="options" @newAddedVideoData="addVideoData" @autoSaveReset="resetAutoSave"></addEditEducation>
              </div>
            </div>
          </draggable>

            <button type="button" class="add-another-education-screen-btn" v-on:click="addNewEducationScreen()">
              Add another screen
            </button>

            <div class="row mt-20" v-if="selectedConsentSection.opType === 'toAdd'">
              <addEditEducation :options="selectedConsentSection" :eConsentData="options" @newAddedVideoData="addVideoData" @autoSaveReset="resetAutoSave"></addEditEducation>
            </div>
            <div class="row mt-20" v-if="selectedConsentSection.opType === 'toOptionalEdit'">
              <addEditEducation :options="selectedConsentSection"  :existingConsent="existingConsents" :eConsentData="options" @newAddedVideoData="addVideoData" @autoSaveReset="resetAutoSave"></addEditEducation>
            </div> 

            <button class="box2-continue-btn" @click="continue3()">
              Continue
            </button>
          </div>
        </b-collapse>
      </div>
      <!--Box 2 End-->
      <div class="box-divider"></div>

      <!--Box 3-->
      <div class="box" :class="{'disable-consent':!flagData.comprehensionEnabled}">
      <div class="d-flex">
        <div class="box-heading mr-auto" @click="box3toggle()" v-bind:class="{ active: innerBoxes.box3, 'disabled-icon': !flagData.comprehensionEnabled}">
          <img v-if="innerBoxes.box3" src="/static/img/econsent/collapse.svg">
          <img v-if="!innerBoxes.box3" src="/static/img/econsent/expand.svg">
         <span>Comprehension</span>
        </div>
        <div class="on-off" :class="{'disabled-icon':!flagData.educationEnabled}">
          <div class="t-switch off"><label>Off</label></div>
          <div class="t-switch">
            <label class="switch">
              <input type="checkbox" v-model="flagData.comprehensionEnabled" @change="onChangeFlag(flagData.comprehensionEnabled, 'comprehensionEnabled')">
              <div class="slider round"></div>
            </label>
          </div>
          <div class="t-switch on"><label>On</label></div>
        </div>
      </div>
        <b-collapse v-model="innerBoxes.box3" :id="innerBoxes.id3">
        <div class="inner-box">
          <div
            class="box3-content"
          >To ensure that your participants fully understand the consent educational materials, a comprehensive quiz will be presented to them. This should be a short quiz with three (3) to five (5) questions.</div>
          <draggable
            v-if="existingConsentData.opType==='toEdit'"
            v-model="quizQuestions"
            :options="{ disabled: draggableQuiz }"
            @start="drag=true"
            @end="drag=false"
            @change="onDragQuiz(consentId)"
          >
            <div
              class="question-panel"
              v-for="(question, index) in quizQuestions"
              :key="question.identifier"
            >
              <div
                class="question-section"
                v-if="addEditQuizQuestion.identifier !== question.identifier"
              >
                <div>
                  <h5 class="heading">{{index + 1}}. {{question.body}}</h5>
                  <div
                    class="description"
                    v-if="question.type=='instruction'"
                  >{{question.description}}</div>
                  <div v-if="question.type!='instruction'">
                    <div class="description" v-for="option in question.options">
                      <input
                        type="radio"
                        :checked="option.sequence==question.expectedAnswer"
                        disabled
                      >
                      &nbsp; {{option.body}}
                    </div>
                  </div>
                </div>
                <button class="edit-btn" v-on:click="editQuizQuestion(question,index)">Edit</button>
              </div>

              <div
                class="row pt-10"
                v-if="addEditQuizQuestion.opType === 'toEdit' && addEditQuizQuestion.identifier === question.identifier"
              >
                <addEditQuiz :options="addEditQuizQuestion" :eConsentData="options" @autoSaveReset="resetAutoSave"></addEditQuiz>
              </div>
            </div>
          </draggable>

          <draggable
            v-if="existingConsentData.opType==='toAdd'"
            v-model="quizQuestions"
            :options="{ disabled: draggableQuiz }"
            @start="drag=true"
            @end="drag=false"
            @change="onDragQuiz(consentId)"
          >
            <div class="question-panel" v-for="(question, index) in quizQuestions" :key="question.identifier">
              <div
                class="question-panel"
                v-if="addEditQuizQuestion.identifier !== question.identifier"
              >
                <div class="question-section">
                  <h5 class="heading">{{index + 1}}. {{question.body}}</h5>
                  <div
                    class="description"
                    v-if="question.type=='instruction'"
                  >{{question.description}}</div>
                  <div v-if="question.type!='instruction'">
                    <div class="description" v-for="option in question.options">
                      <input
                        type="radio"
                        :checked="option.sequence==question.expectedAnswer"
                        disabled
                      >
                      &nbsp; {{option.body}}
                    </div>
                  </div>
                </div>
                <div>
                  <button class="edit-btn" v-on:click="editOptionalQuizQuestion(question,index)">Edit</button>
                </div>
              </div>
              <div
                class="row pt-10"
                v-if="addEditQuizQuestion.opType === 'toEdit' && addEditQuizQuestion.identifier === question.identifier"
              >
                <addEditQuiz :options="addEditQuizQuestion" :eConsentData="options" @autoSaveReset="resetAutoSave"></addEditQuiz>
              </div>
            </div>
          </draggable>

          
          <draggable
            v-if="existingConsentData.opType==='toOptionalEdit'"
            v-model="quizQuestions" 
            :options="{ disabled: true }"
          >
            <div class="question-panel" v-for="(question, index) in quizQuestions" :key="question.identifier">
              <div
                class="question-panel"
                v-if="addEditQuizQuestion.identifier !== question.identifier"
              >
                <div class="question-section">
                  <h5 class="heading">{{index + 1}}. {{question.body}}</h5>
                  <div
                    class="description"
                    v-if="question.type=='instruction'"
                  >{{question.description}}</div>
                  <div v-if="question.type!='instruction'">
                    <div class="description" v-for="option in question.options">
                      <input
                        type="radio"
                        :checked="option.sequence==question.expectedAnswer"
                        disabled
                      >
                      &nbsp; {{option.body}}
                    </div>
                  </div>
                </div>
                <div>
                  <button class="edit-btn" v-on:click="editQuizQuestion(question,index)">Edit</button>
                </div>
              </div>
              <div
                class="row pt-10"
                v-if="addEditQuizQuestion.opType === 'toEdit' && addEditQuizQuestion.identifier === question.identifier"
              >
                <addEditQuiz :options="addEditQuizQuestion" :eConsentData="options" @autoSaveReset="resetAutoSave"></addEditQuiz>
              </div>
            </div>
          </draggable>

            <div class="pt-10" v-if="addEditQuizQuestion.opType === 'toAdd'">
              <addEditQuiz :options="addEditQuizQuestion" :eConsentData="options" @autoSaveReset="resetAutoSave"></addEditQuiz>
            </div>

            <button type="button" class="add-a-question-btn" v-on:click="addNewQuizQuestion()">
              Add a question
            </button>
            <button type="button" class="continue-btn3" @click="continue4()">
              Continue
            </button>
          </div>
        </b-collapse>
      </div>
      <!--Box 3 End-->
      <div class="box-divider"></div>

      <!--Box 4-->
      <div class="box" :class="{ 'disable-consent': !flagData.documentAndSignatureEnabled }">
        <div class="d-flex">
          <div
            class="box-heading mr-auto"
            @click="box4toggle()"
            v-bind:class="{
              active: innerBoxes.box4,
              'disabled-icon': !flagData.documentAndSignatureEnabled
            }"
          >
            <img v-if="innerBoxes.box4" src="/static/img/econsent/collapse.svg" />
            <img v-if="!innerBoxes.box4" src="/static/img/econsent/expand.svg" />
            <span>Document & signature</span>
          </div>
          <div class="on-off">
            <div class="t-switch off"><label>Off</label></div>
            <div class="t-switch">
              <label class="switch">
                <input type="checkbox" v-if="existingConsentData.opType==='toOptionalEdit'" disabled>
                <input type="checkbox" v-model="flagData.documentAndSignatureEnabled" @change="onChangeFlag(flagData.documentAndSignatureEnabled, 'documentAndSignatureEnabled')" />
                <div v-if="existingConsentData.opType==='toOptionalEdit'" class="slider round inactive"></div>
              <div v-else class="slider round"></div>
              </label>
            </div>
            <div class="t-switch on"><label>On</label></div>
          </div>
        </div>
        <b-collapse v-model="innerBoxes.box4" :id="innerBoxes.id4">
          <div class="inner-box">
            <div class="document-section" v-if="consentDocReadMode">
              <!--<div class="heading1">Consent name</div>
            <div class="input1"><input type="text" placeholder="Enter the name of this consent"></div>-->
              <div class="heading2">Enter and format the consent</div>
              <!--<div class="input2"><textarea placeholder="Enter consent here" ref="myTextEditor" v-model="consentDocData.htmlDocument"></textarea></div>-->
              <div v-if="consentDocReadMode" class="input2">
                <quill-editor class="bg-white" ref="myTextEditor" v-model="consentDocData.htmlDocument" :options="editorOptionsMore" @change="onEditorChange($event)" @focus="onEditorFocus" @ready="onEditorReady($event)"></quill-editor>
              </div>
              <div>
                <div class="heading3" v-if="consentDocReadMode">
                  Upload a copy of the consent document
                </div>
                <div class="text1">Format accepted: .pdf</div>

                <div class="pt-20 clear-float row" v-for="(doc, index) in consentDocData.documentFiles" :key="index">
                  <div class="col-sm-4">
                    <div class="pb-10 lang-text">
                      {{ doc.language.display_name }}
                    </div>
                    <div class="fs-14 color_blue pb-5" v-if="doc.pdfName && !doc.pdfLink">
                      <span class="icon_section" v-if="!doc.pdfName">
                        <span class="fa fa-file"></span>
                      </span>
                    </div>
                    <div class="fs-14 color_blue pb-5" v-if="doc.pdfName">
                      <span class="icon_section">
                        <span class="fa fa-file"></span>
                      </span>
                      {{ doc.pdfName }}
                    </div>
                    <div class="color_red fs-12 cursor_pointer" v-if="(existingConsentData.opType === 'toAdd' || existingConsentData.opType === 'toEdit') && doc.pdfName" v-on:click="removeConsentFile(doc, index)">
                      Remove consent file
                    </div>
                    <div class="color_red fs-12 cursor_pointer" v-if="existingConsentData.opType === 'toOptionalEdit' && doc.pdfName" v-on:click="removeOptionalConsentFile(doc, index)">
                      Remove consent file
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <div class>
                      <div class="file-upload">
                        <input type="file" class="file-input" id="consent_section_doc" v-on:change="onDocFileSelection($event, index, doc.language)" accept="application/pdf" />
                        <span class="file-input">Upload</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box-divider-1"></div>
              <div class="disclaimer-section">
                <div class="heading3">Add an additional disclaimer</div>
                <div class="text1">
                  If this option is configured, participants will need to acknowledge they read the disclaimer by checking the checkbox before moving to the next section.
                </div>
                <div v-if="disclaimerList.length > 0" class="input-boxes mt-24 pl-16 mr-70">
                  <transition-group name="list" tag="p">
                    <div v-for="(disclaimerObj, dIndex) in disclaimerList" :key="disclaimerObj.disclaimerId ? disclaimerObj.disclaimerId : disclaimerObj.dynamicDisclaimerID" class="form-group">
                      <label class="heading3">Disclaimer {{ dIndex + 1 }}</label>
                      <!-- <textarea v-model="disclaimerObj.disclaimer" class="form-control" placeholder="Enter disclaimer content"></textarea> -->
                      <quill-editor class="bg-white" ref="consentDisclaimerEditor" v-model="disclaimerObj.disclaimer" :options="editorDisclaimerOptionsFew"> </quill-editor>
                      <span @click="removeDisclaimer(dIndex)" class="disclaimer-remove">Remove</span>
                      <div class="text1 mt-25">
                        Set disclaimer as required or optional
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="btn-group">
                            <label class="btn btn-default">
                              <input type="radio" class="disclaimer-radio" :name="'Disclaimer' + dIndex" v-model="disclaimerObj.required" value="true" />
                              <span class="ml-5">Required</span>
                            </label>
                            <label class="btn btn-default"> <input type="radio" class="disclaimer-radio" :name="'Disclaimer' + dIndex" v-model="disclaimerObj.required" value="false" /><span class="ml-5">Optional</span> </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </transition-group>
                </div>
                <button @click="addDisclaimer()" type="button" class="disclaimer-btn">
                  Add a disclaimer
                </button>
              </div>
              <div class="box-divider-1"></div>
              <div class="row">
                <div class="Digital-signature">Digital signature</div>
                <div class="on-off-1">
                  <div class="t-switch off"><label>Off</label></div>
                  <div class="t-switch">
                    <label class="switch">
                      <input type="checkbox" v-if="existingConsentData.opType==='toOptionalEdit'" disabled>
                      <input type="checkbox" v-model="flagData.digitalSignatureEnabled" @change="onChangeFlag(flagData.digitalSignatureEnabled, 'digitalSignatureEnabled')" />
                      <div v-if="existingConsentData.opType==='toOptionalEdit'" class="slider round inactive"></div>
                      <div v-else class="slider round"></div>
                    </label>
                  </div>
                  <div class="t-switch on"><label>On</label></div>
                </div>
              </div>
              <div class="btns">
                <button class="cancel-btn" v-on:click="cancelScreen()">
                  Cancel
                </button>
                <button class="save-btn" v-if="existingConsentData.opType==='toOptionalEdit'" v-on:click="saveOptionalConsentDocumentScreen(consentDocData)">Save</button>
                <button class="save-btn" v-else v-on:click="saveConsentDocumentScreen(consentDocData)">
                  Save
                </button>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
      <!--Box 4 End-->
      <div class="bottom-section">
        <div class="left-block" v-if="existingConsentData.opType !== 'toOptionalEdit'">
          <img src="/static/img/econsent/delete.svg" class="delete-btn" v-if="consentId" @click="deleteConsent(consentId)" />
        </div>

        <!-- <div class="right-block">
                    <button class="save-btn">Save</button>
        </div>-->
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="back-button pt-10">
      <span class="back_link" v-on:click="goBack()"> <i class="fa fa-chevron-left" aria-hidden="true"></i> Back </span>
    </div>
    <videoUploadModal ref="videoUploadModal" @insertVideo="insertVideoInEditor" :moduleName="onEconsentModuleName" @stopAutoSave="stopAutoSave" />
  </div>
</template>

<script>
import _ from "lodash";
import toastr from "toastr";
import draggable from "vuedraggable";
import swal from "sweetalert2";
import nprogress from "nprogress";
import "nprogress/nprogress.css";
import addEditEducation from "../common/add-edit-multi-econsent-education";
import addEditQuiz from "../common/add-edit-multi-econsent-quiz";
import videoUploadModal from "@/components/common/video-upload-modal";
import { Quill, quillEditor } from "vue-quill-editor";
import localStorage from "@/services/localStorage";
import QlVideoUploadService from "@/services/ql-video-upload";
import * as PresignedUrlManager from "../services/managing-one-time-presigned-urls";

const MODULE_NAME = "eConsent";
let dynamicDisclaimerID = 0;
export default {
  name: "multi-econsent",
  data() {
    return {
      existingConsentList: this.existingConsent,
      quizQuestions: [],
      studyId: null,
      consentId: null,
      opType : "toOptionalEdit",
      noneditableEconsentName: "",
      newConsentId: null,
      editorOptionsMore: {
        placeholder: "Enter your study consent",
        readOnly: false,
        modules: {
          toolbar: {
            container: [
              ["bold", "italic", "underline", "strike"],
              [{ list: "ordered" }, { list: "bullet" }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              // [{ color: [] }, { background: [] }],
              // [{ font: [] }],
              [{ align: [] }],
              ["link", "image", "video", "localVideoUpload"],
              ["clean"]
            ],
            handlers: {
              localVideoUpload: this.customVideoButtonHandler
            }
          }
        }
      },
      fileSelected: [],
      selectedConsentSection: {
        consentId: "",
        sectionId: "",
        sectionType: "default",
        sectionNumber: "",
        sectionTitle: "",
        sectionImage: "",
        sectionImageTemp: "",
        sectionSummary: "",
        sectionHtmlContent: "",
        opType: ""
      },
      consentSections: [],
      documentSection: [],
      innerBoxes: {
        box1: true,
        box2: false,
        box3: false,
        box4: false,
        id1: "1",
        id2: "2",
        id3: "3",
        id4: "4"
      },
      addEditQuizQuestion: {
        type: "default",
        body: "",
        sequence: 1,
        description: "",
        expectedAnswer: "",
        options: [
          { body: "", sequence: 1 },
          { body: "", sequence: 2 }
        ],
        opType: "",
        consentId: ""
      },
      existingConsentData: this.options,
      newConsentName: "",
      newConsentData: [],
      educationSection: {
        opType: "",
        data: []
      },
      consentDocReadMode: true,
      appLangaScript: "window.initApplanga = function() {        if(typeof window.ApplangaNative !== 'undefined') {  window.ApplangaNative.loadScript();        } else { setTimeout(window.initApplanga, 180); }    }; window.initApplanga();",
      consentDocData: {
        htmlDocument: null,
        documentFiles: []
      },
      supportedLanguages: null,
      imageTypeError: true,
      disclaimerList: [],
      apiDiscliamerResponse: [],
      editorDisclaimerOptionsFew: {
        placeholder: "Enter disclaimer content",
        readOnly: false,
        modules: {
          toolbar: ["bold", "italic", "underline"]
        }
      },
      eConsentDetail: {},
      educationEnabled: true,
      comprehensionEnabled: true,
      documentAndSignatureEnabled: true,
      digitalSignatureEnabled: true,
      flagData: {},
      consentDataResp: {},
      editorFocused: null,
      onEconsentModuleName: MODULE_NAME,
      qlVideoUpload: null,
      onloadParticipantS3VideoScript: null,
      participantOnloadHeadStylesText: null,
      autoSaveElementTimeout: process.env.VUE_APP_AUTO_SAVE_ELEMENT_LIB_TIMEOUT
    };
  },
  props: ["options", "existingConsent", 'dataVantConsentBasicDetails'],
  mounted() {
    this.noneditableEconsentName = this.options.consentName;
    this.qlVideoUpload = new QlVideoUploadService(MODULE_NAME, this.$route.params.studyId, localStorage.getItem("clientId"));
    this.onloadParticipantS3VideoScript = this.qlVideoUpload.manageParticipantVideoDisplayScript;
    this.participantOnloadHeadStylesText = this.qlVideoUpload.videoStylesText;
    const VideoBlot = require("@/utils/quill-video-tag-blot");
    Quill.register(VideoBlot);
    window.scrollTo(0, 0);
    this.studyId = this.$route.params.studyId;
    this.consentId = this.$route.params.consentId;
    this.setConsentId();
    this.getStudyDetail();
    this.setFlagData();
    this.initLocalVideoUploadButton();
    this.startAutoSave();
    this.setOptionalConsentId();
    this.setOptionalFlagData();
  },
  computed: {
    addedConsentSection() {
      return this.$store.getters.getAddedConsentSection;
    },
    addedOptionalConsentSection() {
      return this.$store.getters.getAddedOptionalConsentSection;
    },
    addedConsentQuiz() {
      return this.$store.getters.getAddedConsentQuiz;
    },
    addedOptionalConsentQuiz() {
      return this.$store.getters.getAddedOptionalConsentQuiz;
    },
    draggableSection() {
      if (this.consentSections <= 0) {
        return false;
      } else if (this.selectedConsentSection.opType === "toAdd" || this.selectedConsentSection.opType === "toEdit") {
        return true;
      }
      return false;
    },
    draggableQuiz() {
      if (this.quizQuestions <= 0) {
        return false;
      } else if (this.addEditQuizQuestion.opType === "toAdd" || this.addEditQuizQuestion.opType === "toEdit") {
        return true;
      }
      return false;
    }
  },
  watch: {
    addedConsentSection: {
      handler(val) {
        if (val) {
          const sectionObj = _.cloneDeep(val);

          let oldSectionHtmlContent = _.cloneDeep(sectionObj.sectionHtmlContent);
          if (oldSectionHtmlContent) {
            oldSectionHtmlContent = `<html><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width, initial-scale=1"><link rel="stylesheet" type="text/css" href="editor.css"</head><body class="ql-editor">${oldSectionHtmlContent}</body></html>`;
          }

          sectionObj.sectionHtmlContent = this.qlVideoUpload.insertDummyUrlToScreen(sectionObj.sectionHtmlContent) ? this.qlVideoUpload.insertDummyUrlToScreen(sectionObj.sectionHtmlContent) : "";

          if (val.sectionId && val.opType === "delete") {
            this.deleteConsentSection(this.studyId, val.sectionId, this.consentId);
          } else if (!val.sectionId && val.opType === "done") {
            // Section with out sectionId === new section
            const fd = new FormData();
            // fd.append('sectionNumber', this.getIndexForNewScreen());
            fd.append("sectionNumber", 2);
            fd.append("sectionType", sectionObj.sectionType);
            fd.append("sectionTitle", sectionObj.sectionTitle);
            fd.append("sectionImage", sectionObj.sectionImage);
            fd.append("sectionSummary", sectionObj.sectionSummary);
            if (sectionObj.sectionHtmlContent && sectionObj.sectionHtmlContent.indexOf("<html><head>") < 0) {
              sectionObj.sectionHtmlContent = `<html><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width, initial-scale=1"><link rel="stylesheet" type="text/css" href="editor.css"></head><body class="ql-editor">${sectionObj.sectionHtmlContent}</body></html>`;
            }
            fd.append("sectionHtmlContent", sectionObj.sectionHtmlContent);
            nprogress.start();
            this.$api.addConsentSectionFactV2(this.studyId, fd, this.consentId).then(
              response => {
                this.selectedConsentSection = {};
                this.$store.dispatch("addConsentSectionAction", this.selectedConsentSection);
                const tempSection = response.data;
                tempSection.sectionHtmlContent = oldSectionHtmlContent;
                const section = this.qlVideoUpload.removeScriptAndStylesFromSingleScrn(tempSection, "sectionHtmlContent");
                this.consentSections.push(section);
                if (!val.autoSave) {
                  toastr.success("Consent section added successfully.");
                }
                nprogress.done();
              },
              error => {
                this.$store.dispatch("addConsentSectionAction", {});
                toastr.error(error.body ? error.body.message : "Error while adding the consent section");
                nprogress.done();
              }
            );
          } else if (val.sectionId && val.opType === "done") {
            // Section with sectionId === existing section
            if (sectionObj.sectionHtmlContent && sectionObj.sectionHtmlContent.indexOf("<html><head>") < 0) {
              sectionObj.sectionHtmlContent = `<html><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width, initial-scale=1"><link rel="stylesheet" type="text/css" href="editor.css"></head><body class="ql-editor">${sectionObj.sectionHtmlContent}</body></html>`;
            }
            const fd = new FormData();
            fd.append("sectionId", sectionObj.sectionId);
            fd.append("sectionType", sectionObj.sectionType);
            fd.append("sectionTitle", sectionObj.sectionTitle);
            fd.append("sectionSummary", sectionObj.sectionSummary);
            fd.append("sectionHtmlContent", sectionObj.sectionHtmlContent);
            fd.append("sectionNumber", sectionObj.sectionNumber);
            if (sectionObj.sectionImage) {
              fd.append("sectionImage", sectionObj.sectionImage);
            }
            fd.append("sectionSummary", sectionObj.sectionSummary);
            if (sectionObj.sectionHtmlContent && sectionObj.sectionHtmlContent.indexOf("<html><head>") < 0) {
              sectionObj.sectionHtmlContent = `<html><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width, initial-scale=1"><link rel="stylesheet" type="text/css" href="editor.css"></head><body class="ql-editor">${sectionObj.sectionHtmlContent}</body></html>`;
            }
            fd.append("sectionHtmlContent", sectionObj.sectionHtmlContent);
            nprogress.start();
            this.$api.updateConsentSectionFactV2(this.studyId, sectionObj.sectionId, fd, this.consentId).then(
              response => {
                const sectionIndex = _.findIndex(this.consentSections, ["sectionId", response.data.sectionId]);
                const tempSection = response.data;
                tempSection.sectionHtmlContent = oldSectionHtmlContent;
                const section = this.qlVideoUpload.removeScriptAndStylesFromSingleScrn(tempSection, "sectionHtmlContent");
                this.consentSections.splice(sectionIndex, 1, section);
                this.selectedConsentSection = {};
                this.$store.dispatch("addConsentSectionAction", this.selectedConsentSection);
                if (!val.autoSave) {
                  toastr.success("Consent updated successfully");
                }
                nprogress.done();
              },
              error => {
                this.$store.dispatch("addConsentSectionAction", {});
                toastr.error(error.body ? error.body.message : "Error while updating the consent section");
                nprogress.done();
              }
            );
          } else if (val.sectionId && val.opType === "toEdit") {
            this.selectedConsentSection.opType = val.opType;
          } else if (val.sectionId && val.opType === "none") {
            const sectionIndex = _.findIndex(this.consentSections, ["sectionId", this.selectedConsentSection.sectionId]);
            this.consentSections.splice(sectionIndex, 1, this.selectedConsentSection);
            this.selectedConsentSection = {};
          } else {
            this.selectedConsentSection = {
              sectionId: "",
              sectionNumber: "",
              sectionTitle: "",
              sectionImage: "",
              sectionSummary: "",
              sectionHtmlContent: "",
              opType: ""
            };
          }
        }
      }
    },
    addedOptionalConsentSection: {   
      handler(val) {
        if (val) {
          const sectionObj = _.cloneDeep(val);
          let oldSectionHtmlContent = _.cloneDeep( sectionObj.sectionHtmlContent );
          if (oldSectionHtmlContent) {
              oldSectionHtmlContent = `<html><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width, initial-scale=1"><link rel="stylesheet" type="text/css" href="editor.css"</head><body class="ql-editor">${
              oldSectionHtmlContent
            }</body></html>`;
          }
          sectionObj.sectionHtmlContent = this.qlVideoUpload.insertDummyUrlToScreen( sectionObj.sectionHtmlContent ) ? this.qlVideoUpload.insertDummyUrlToScreen( sectionObj.sectionHtmlContent ) : '';
          if (val.sectionId && val.opType === 'delete') {
            this.deleteOptionalConsentSection(
              this.studyId,
              val.sectionId,
              this.consentId,
            );
          } else if (!val.sectionId && val.opType === 'done') {
            // Section with out sectionId === new section
            const fd = new FormData();
            // fd.append('sectionNumber', this.getIndexForNewScreen());
            fd.append('sectionNumber', 2);
            fd.append('sectionType', sectionObj.sectionType);
            fd.append('sectionTitle', sectionObj.sectionTitle);
            fd.append('sectionImage', sectionObj.sectionImage);
            fd.append('sectionSummary', sectionObj.sectionSummary);
            if (
              sectionObj.sectionHtmlContent &&
              sectionObj.sectionHtmlContent.indexOf('<html><head>') < 0
            ) {
              sectionObj.sectionHtmlContent = `<html><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width, initial-scale=1"><link rel="stylesheet" type="text/css" href="editor.css"></head><body class="ql-editor">${
                sectionObj.sectionHtmlContent
              }</body></html>`;
            }
            fd.append('sectionHtmlContent', sectionObj.sectionHtmlContent);         
            nprogress.start();     
            this.$api
              .addOptionalConsentSection(this.studyId, this.consentId, fd)  // to check this API
              .then(
                response => {
                  this.selectedConsentSection = {};  
                  this.$store.dispatch(
                    'addOptionalConsentSectionAction',
                    this.selectedConsentSection,
                  );
                  let tempSection = response.data;
                  tempSection.sectionHtmlContent = oldSectionHtmlContent;
                 
                  let section = this.qlVideoUpload.removeScriptAndStylesFromSingleScrn(tempSection, "sectionHtmlContent")
                  this.consentSections.push(section);
                  if (!val.autoSave){
                    toastr.success('Consent section added successfully.');
                  }
                  nprogress.done();
                },
                error => {
                  this.$store.dispatch('addOptionalConsentSectionAction', {});
                  toastr.error(
                    error.body
                      ? error.body.message
                      : 'Error while adding the consent section',
                  );
                  nprogress.done();
                },
              );
          } else if (val.sectionId && val.opType === 'done') {
            // Section with sectionId === existing section
            if (
              sectionObj.sectionHtmlContent &&
              sectionObj.sectionHtmlContent.indexOf('<html><head>') < 0
            ) {
              sectionObj.sectionHtmlContent = `<html><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width, initial-scale=1"><link rel="stylesheet" type="text/css" href="editor.css"></head><body class="ql-editor">${
                sectionObj.sectionHtmlContent
              }</body></html>`; // eslint-disable-line
            }
            const fd = new FormData();
            fd.append('sectionId', sectionObj.sectionId);
            fd.append('sectionType', sectionObj.sectionType);
            fd.append('sectionTitle', sectionObj.sectionTitle);
            fd.append('sectionSummary', sectionObj.sectionSummary);
            fd.append('sectionHtmlContent', sectionObj.sectionHtmlContent);
            fd.append('sectionNumber', sectionObj.sectionNumber);
            if (sectionObj.sectionImage) {
              fd.append('sectionImage', sectionObj.sectionImage);
            }
            fd.append('sectionSummary', sectionObj.sectionSummary);
            if (
              sectionObj.sectionHtmlContent &&
              sectionObj.sectionHtmlContent.indexOf('<html><head>') < 0
            ) {
              sectionObj.sectionHtmlContent = `<html><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width, initial-scale=1"><link rel="stylesheet" type="text/css" href="editor.css"></head><body class="ql-editor">${
                sectionObj.sectionHtmlContent
              }</body></html>`;
            }
            fd.append('sectionHtmlContent', sectionObj.sectionHtmlContent);
            nprogress.start();
            this.$api
              .updateOptionalConsentSection(
                this.studyId,
                sectionObj.sectionId,
                fd,
                this.consentId,
              )
              .then(
                response => {
                  const sectionIndex = _.findIndex(this.consentSections, [
                    'sectionId',
                    response.data.sectionId,
                  ]);
                  let tempSection = response.data;
                  tempSection.sectionHtmlContent = oldSectionHtmlContent;
                  let section = this.qlVideoUpload.removeScriptAndStylesFromSingleScrn(tempSection, "sectionHtmlContent");
                  this.consentSections.splice(sectionIndex, 1, section);
                  this.selectedConsentSection = {};
                  this.$store.dispatch(
                    'addOptionalConsentSectionAction',
                    this.selectedConsentSection,
                  );
                  if (!val.autoSave){
                    toastr.success('Consent updated successfully');
                  }
                  nprogress.done();
                },
                error => {
                  this.$store.dispatch('addOptionalConsentSectionAction', {});
                  toastr.error(
                    error.body
                      ? error.body.message
                      : 'Error while updating the consent section',
                  );
                  nprogress.done();
                },
              );
          } else if (val.sectionId && val.opType === 'toOptionalEdit') {
            this.selectedConsentSection.opType = val.opType;
          } else if (val.sectionId && val.opType === 'none') {
            const sectionIndex = _.findIndex(this.consentSections, [
              'sectionId',
              this.selectedConsentSection.sectionId,
            ]);
            this.consentSections.splice(
              sectionIndex,
              1,
              this.selectedConsentSection,
            );
            this.selectedConsentSection = {};
          } else {
            this.selectedConsentSection = {
              sectionId: '',
              sectionNumber: '',
              sectionTitle: '',
              sectionImage: '',
              sectionSummary: '',
              sectionHtmlContent: '',
              opType: '',
            };
          }
        }
      },
    },
    addedConsentQuiz: {
      handler(val) {
        if (val) {
          const quizObj = val;
          if (val.identifier && val.opType === "delete") {
            this.deleteConsentQuiz(this.studyId, this.consentId, val.identifier);
          } else if (!val.identifier && val.opType === "done") {
            // quiz question with out id === new quiz question
            quizObj.sequence = this.quizQuestions.length + 1;
            nprogress.start();
            this.$api.addConsentQuizFactV2(this.studyId, quizObj, quizObj.consentId).then(
              response => {
                this.addEditQuizQuestion = {};
                this.$store.dispatch("addConsentQuizAction", this.addEditQuizQuestion);
                if (!val.autoSave) {
                  toastr.success("Quiz question added successfully");
                }
                this.quizQuestions.push(response.data);
                nprogress.done();
              },
              error => {
                this.$store.dispatch("addConsentQuizAction", {});
                if (!val.autoSave) {
                  toastr.error(error.body ? error.body.message : "Error while adding quiz question");
                }
                nprogress.done();
              }
            );
          } else if (val.identifier && val.opType === "done") {
            // quiz question with id === existing quiz question
            nprogress.start();
            this.$api.updateConsentQuizFactV2(this.studyId, quizObj, this.consentId).then(
              response => {
                if (!val.autoSave) {
                  toastr.success("Quiz question updated successfully");
                }
                const sectionIndex = _.findIndex(this.quizQuestions, ["identifier", response.data.identifier]);
                this.quizQuestions.splice(sectionIndex, 1, response.data);
                this.addEditQuizQuestion = {};
                this.$store.dispatch("addConsentQuizAction", this.addEditQuizQuestion);
                nprogress.done();
              },
              error => {
                this.$store.dispatch("addConsentQuizAction", {});
                if (!val.autoSave) {
                  toastr.error(error.body ? error.body.message : "Error while updating quiz question");
                }
                nprogress.done();
              }
            );
          } else if (val.identifier && val.opType === "toEdit") {
            this.addEditQuizQuestion.opType = val.opType;
          } else if (val.identifier && val.opType === "none") {
            const sectionIndex = _.findIndex(this.quizQuestions, ["identifier", this.addEditQuizQuestion.identifier]);
            this.quizQuestions.splice(sectionIndex, 1, this.addEditQuizQuestion);
            this.addEditQuizQuestion = {};
          } else {
            this.addEditQuizQuestion = {
              type: "default",
              body: "",
              sequence: 1,
              description: "",
              expectedAnswer: "",
              options: [
                { body: "", sequence: 1 },
                { body: "", sequence: 2 }
              ],
              opType: ""
            };
          }
        }
      }
    },
    addedOptionalConsentQuiz: {
      handler(val) {
        
        if (val) {
          const quizObj = val;
          if (val.identifier && val.opType === 'delete') {
            this.deleteOptionalQuizSection(
              this.studyId,
              this.consentId,
              val.identifier,
            );
          } else if (!val.identifier && val.opType === 'done') {
            // quiz question with out id === new quiz question
            quizObj.sequence = this.quizQuestions.length + 1;
            nprogress.start();
            this.$api
              .addOptionalQuizSection(this.studyId, quizObj, quizObj.consentId)
              .then(
                response => {
                  this.addEditQuizQuestion = {};
                  this.$store.dispatch(
                    'addOptionalConsentQuizAction',
                    this.addEditQuizQuestion,
                  );
                  if (!val.autoSave){
                    toastr.success('Quiz question added successfully');
                  }
                  this.quizQuestions.push(response.data);
                  nprogress.done();
                },
                error => {
                  this.$store.dispatch('addOptionalonsentQuizAction', {});
                  if (!val.autoSave){
                    toastr.error(
                      error.body
                        ? error.body.message
                        : 'Error while adding quiz question',
                    );
                  }
                  nprogress.done();
                },
              );
          } else if (val.identifier && val.opType === 'done') {
            nprogress.start();
            this.$api
              .updateOptionalQuizSection(this.studyId, quizObj, this.consentId)
              .then(
                response => {
                  if (!val.autoSave){
                    toastr.success('Quiz question updated successfully');
                  }
                  const sectionIndex = _.findIndex(this.quizQuestions, [
                    'identifier',
                    response.data.identifier,
                  ]);
                  this.quizQuestions.splice(sectionIndex, 1, response.data);
                  this.addEditQuizQuestion = {};
                  this.$store.dispatch(
                    'addOptionalConsentQuizAction',
                    this.addEditQuizQuestion,
                  );
                  nprogress.done();
                },
                error => {
                  this.$store.dispatch('addOptionalConsentQuizAction', {});
                  if (!val.autoSave){
                    toastr.error(
                      error.body
                        ? error.body.message
                        : 'Error while updating quiz question',
                    );
                  }
                  nprogress.done();
                },
              );
          } else if (val.identifier && val.opType === 'toOptionalEdit') {
            this.addEditQuizQuestion.opType = val.opType;
          } 
            else if (val.identifier && val.opType === 'none') {
            const sectionIndex = _.findIndex(this.quizQuestions, [
              'identifier',
              this.addEditQuizQuestion.identifier,
            ]);
            this.quizQuestions.splice(
              sectionIndex,
              1,
              this.addEditQuizQuestion,
            );
            this.addEditQuizQuestion = {};
          } else {
            this.addEditQuizQuestion = {
              type: 'default',
              body: '',
              sequence: 1,
              description: '',
              expectedAnswer: '',
              options: [{ body: '', sequence: 1 }, { body: '', sequence: 2 }],
              opType: '',
            };
          }
        }
      },
    }
  },
  methods: {
    setFlagData() {
      if (this.options.consentId && this.options.opType == "toEdit") {
        this.flagData = {
          consentId: this.options.consentId,
          studyId: this.studyId,
          consentName: this.options.consentName,
          educationEnabled: this.options.educationEnabled,
          comprehensionEnabled: this.options.comprehensionEnabled,
          documentAndSignatureEnabled: this.options.documentAndSignatureEnabled,
          digitalSignatureEnabled: this.options.digitalSignatureEnabled
        };
      } else {
        this.flagData = {
          consentId: "",
          studyId: this.studyId,
          consentName: "",
          educationEnabled: true,
          comprehensionEnabled: true,
          documentAndSignatureEnabled: true,
          digitalSignatureEnabled: true
        };
      }
    },
    setOptionalFlagData() {
      if(this.options.consentId && this.options.opType == 'toOptionalEdit'){
          this.flagData = {
          consentId: this.options.consentId,
          studyId: this.studyId,
          consentName:this.options.consentName,
          educationEnabled: this.dataVantConsentBasicDetails[0].educationEnabled,
          comprehensionEnabled: this.dataVantConsentBasicDetails[0].comprehensionEnabled,
          documentAndSignatureEnabled: this.dataVantConsentBasicDetails[0].documentAndSignatureEnabled,
          digitalSignatureEnabled: this.dataVantConsentBasicDetails[0].digitalSignatureEnabled
        }
      }
    },
    onEditorChange(event) {
      this.resetAutoSave();
      const elem = document.createElement("div");
      elem.innerHTML = event.html;
      const images = elem.getElementsByTagName("img");
      this.imageTypeError = false;
      for (let i = 0; i < images.length; i++) {
        const [imageType] = images[i].src.split(";");
        const [type] = imageType.split("/");
        if (!!type && type.toLowerCase() != "png") {
          this.imageTypeError = true;
          break;
        }
      }
    },
    box2toggle() {
      if (this.checkConsentId()) {
        toastr.error("Please enter consent name first");
      } else {
        this.innerBoxes.box2 = !this.innerBoxes.box2;
      }
    },
    box3toggle() {
      if (this.checkConsentId()) {
        toastr.error("Please enter consent name first");
      } else {
        this.innerBoxes.box3 = !this.innerBoxes.box3;
      }
    },
    box4toggle() {
      if (this.checkConsentId()) {
        toastr.error("Please enter consent name first");
      } else {
        this.innerBoxes.box4 = !this.innerBoxes.box4;
      }
    },
    checkConsentId() {
      if (this.existingConsentData.opType === "toAdd") {
        if (this.newConsentId === null || this.newConsentId === "") {
          return true;
        }
        return false;
      }
      return false;
    },
    nextChangeConsentName(autoSave = false) {
      const that = this;
      const cname = that.existingConsentData.consentName;
      if (cname === "" || cname === undefined) {
        if (!autoSave) {
          toastr.error("Please enter consent name");
        }
      } else if (that.existingConsentList != null && that.existingConsentList.length > 0) {
        const existingFilterList = that.existingConsentList.filter(el => el.consentName != this.noneditableEconsentName);
        const filterList = existingFilterList.filter(x => x.consentName == cname);
        if (filterList != null && filterList.length > 0) {
          if (!autoSave) {
            toastr.error("A consent with this name already exists.");
          }
        } else {
          that.step2Edit();
        }
      } else {
        that.step2Edit();
      }
    },
    optionalEditConsent() {
      const that = this;
      that.step2Edit();   
    },
    step2Edit() {
      if (this.flagData.educationEnabled) {
        this.innerBoxes.box2 = true;
      } else {
        if (this.flagData.comprehensionEnabled) {
          this.innerBoxes.box3 = true;
        } else {
          if (this.flagData.documentAndSignatureEnabled) {
            this.innerBoxes.box4 = true;
          } else {
            this.innerBoxes.box4 = false;
          }
          this.innerBoxes.box2 = false;
          this.innerBoxes.box3 = false;
        }
        this.innerBoxes.box2 = false;
      }
      this.innerBoxes.box1 = true;
      this.$forceUpdate();
    },
    goBack() {
      if (!this.flagData.educationEnabled && !this.flagData.comprehensionEnabled && !this.flagData.documentAndSignatureEnabled) {
        toastr.error("Please enable at least one of the sub-modules in " + this.existingConsentData.consentName);
        return;
      }
      this.existingConsentData = "";
      this.$emit("exit", true);
    },
    tempChangeConsentName(autoSave = false) {
      const that = this;

      const cname = that.existingConsentData.consentName;

      if (cname === "" || cname === undefined) {
        // toastr.error('Please enter consent name');
      } else if (that.existingConsentList != null && that.existingConsentList.length > 0) {
        const existingFilterList = that.existingConsentList.filter(el => el.consentName != this.noneditableEconsentName);
        const filterList = existingFilterList.filter(x => x.consentName == cname);
        if (filterList != null && filterList.length > 0) {
          // toastr.error('A consnet with this name already exists.');
        } else {
          that.updateConsentName(autoSave);
        }
      } else {
        that.updateConsentName(autoSave);
      }
    },

    updateConsentName(autoSave = false) {
      const that = this;
      nprogress.start();
      that.$api.updateConsentName(that.studyId, that.existingConsentData.consentId, that.existingConsentData.consentName).then(
        () => {
          that.innerBoxes.box1 = true;
          that.innerBoxes.box2 = true;
          if (!autoSave) {
            toastr.success("Consent name updated successfully.");
          }
          nprogress.done();
        },
        error => {
          if (!autoSave) {
            toastr.error(error.body && error.body.message ? error.body.message : "Error while updating consent name.");
          }
          nprogress.done();
        }
      );
    },
    deleteConsent(consentId) {
      swal({
        title: "Are you sure you want to delete this consent?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Delete"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          nprogress.start();
          this.$api.deleteConsentData(this.studyId, consentId).then(
            () => {
              toastr.success("Consent deleted successfully.");
              this.$emit("exit", true);
              this.editorFocused = null;
              nprogress.done();
            },
            error => {
              toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the study details");
              nprogress.done();
            }
          );
        }
      });
    },
    deleteConsentQuiz(studyId, consentId, questionId) {
      swal({
        title: "Are you sure you want to delete this consent quiz question?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#f16559",
        confirmButtonText: "Cancel",
        cancelButtonText: "Delete"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          nprogress.start();
          this.$api.deleteConsentQuizFactV2(studyId, consentId, questionId).then(
            () => {
              const questionIndex = _.findIndex(this.quizQuestions, ["identifier", questionId]);
              this.quizQuestions.splice(questionIndex, 1);
              this.addEditQuizQuestion = {};
              toastr.success("Quiz question deleted successfully");
              this.$store.dispatch("addConsentQuizAction", this.addEditQuizQuestion);
              nprogress.done();
            },
            error => {
              toastr.error(error.body ? error.body.message : "Error while adding the quiz question");
              nprogress.done();
            }
          );
        }
      });
    },   
    deleteOptionalQuizSection(studyId, consentId, questionId) {
      swal({
        title: 'Are you sure you want to delete this consent quiz question?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#b8c7ce',
        cancelButtonColor: '#f16559',
        confirmButtonText: 'Cancel',
        cancelButtonText: 'Delete',
      }).then(({ dismiss }) => {
        if (dismiss === 'cancel') {
          nprogress.start();
          this.$api
            .deleteOptionalDatavantQuizSection(studyId, consentId, questionId)
            .then(
              () => {
                const questionIndex = _.findIndex(this.quizQuestions, [
                  'identifier',
                  questionId,
                ]);
                this.quizQuestions.splice(questionIndex, 1);
                this.addEditQuizQuestion = {};
                toastr.success('Quiz question deleted successfully');
                this.$store.dispatch(
                  'addOptionalConsentQuizAction',
                  this.addEditQuizQuestion,
                );
                nprogress.done();
              },
              error => {
                toastr.error(
                  error.body
                    ? error.body.message
                    : 'Error while adding the quiz question',
                );
                nprogress.done();
              },
            );
        }
      });
    },
    loadQuestion() {
      if (this.existingConsentData.opType === "toEdit" || this.existingConsentData.opType === 'toOptionalEdit') {
        this.consentId = this.existingConsentData.consentId;

        if (this.existingConsentData.sections != null && this.existingConsentData.sections != undefined) {
          this.consentSections = this.existingConsentData.sections;
        }

        if (this.existingConsentData.quiz != null && this.existingConsentData.quiz != undefined) {
          this.quizQuestions = this.existingConsentData.quiz.questions;
        }

        if (this.existingConsentData.documents != null && this.existingConsentData.documents != undefined && !Array.isArray(this.existingConsentData.documents)) {
          this.documentSection = this.existingConsentData.documents;

          this.consentDocData["htmlDocument"] = this.qlVideoUpload.removeScriptAndStylesFromSingleScrn(this.existingConsentData.documents, "htmlDocument")["htmlDocument"];

          this.qlVideoUpload.replaceSignedVideoS3UrlFforSingleScreen(this.consentDocData, "htmlDocument", this.options.participantVideos);
          // only support default language / or only for old studies
          this.supportedLanguages.map(lang => {
            if (lang.name.toLowerCase() == "english") {
              this.consentDocData.documentFiles.push({
                file: null,
                pdfLink: this.existingConsentData.documents.pdfLink,
                pdfName: this.existingConsentData.documents.pdfName,
                language: this.existingConsentData.documents.language
              });
            } else {
              this.consentDocData.documentFiles.push({
                file: null,
                pdfLink: null,
                pdfName: null,
                language: lang
              });
            }
          });
        } else if (Array.isArray(this.existingConsentData.documents)) {
          this.consentDocData["htmlDocument"] = this.qlVideoUpload.removeScriptAndStylesFromSingleScrn(this.existingConsentData.documents[0], "htmlDocument")["htmlDocument"];
          this.qlVideoUpload.replaceSignedVideoS3UrlFforSingleScreen(this.consentDocData, "htmlDocument", this.options.participantVideos);
          this.supportedLanguages.map(lang => {
            const document = this.fetchSupportedLanguage(lang);
            if (document.doc) {
              this.consentDocData.documentFiles.push({
                file: null,
                pdfLink: document.doc.pdfLink,
                pdfName: document.doc.pdfName,
                language: document.doc.language
              });
            } else if (document.lang) {
              this.consentDocData.documentFiles.push({
                file: null,
                pdfLink: null,
                pdfName: null,
                language: document.lang
              });
            }
          });
        } else {
          this.supportedLanguages.map(lang => {
            this.consentDocData.documentFiles.push({
              file: null,
              pdfLink: null,
              pdfName: null,
              language: lang
            });
          });
        }
      } else {
        if (this.supportedLanguages && this.supportedLanguages.length > 0) {
          this.supportedLanguages.map(lang => {
            this.consentDocData.documentFiles.push({
              file: null,
              pdfLink: null,
              pdfName: null,
              language: lang
            });
          });
        }
      }
    },
    fetchSupportedLanguage(langObj) {
      const languageDoc = this.existingConsentData.documents.filter(doc => {
        if (doc.language.language_id == langObj.language_id) {
          return { doc: doc, lang: null };
        }
      });

      return languageDoc.length != 0 ? { doc: languageDoc[0], lang: languageDoc[0].language } : { doc: null, lang: langObj };
    },
    continue4() {
      this.innerBoxes.box3 = false;
      if (this.flagData.documentAndSignatureEnabled) {
        this.innerBoxes.box4 = true;
      } else {
        this.innerBoxes.box4 = false;
      }
    },
    continue3() {
      if (this.flagData.comprehensionEnabled) {
        this.innerBoxes.box2 = false;
        this.innerBoxes.box3 = true;
      } else {
        if (this.flagData.documentAndSignatureEnabled) {
          this.innerBoxes.box4 = true;
        } else {
          this.innerBoxes.box4 = false;
        }
        this.innerBoxes.box2 = false;
        this.innerBoxes.box3 = false;
      }
    },
    deleteConsentSection(studyId, sectionId, consentId) {
      nprogress.start();
      this.$api.deleteConsentSectionFactV2(studyId, sectionId, consentId).then(
        () => {
          const sectionIndex = _.findIndex(this.consentSections, ["sectionId", sectionId]);
          this.consentSections.splice(sectionIndex, 1);
          this.selectedConsentSection = {};
          toastr.success("Consent section deleted successfully");
          this.$store.dispatch("addConsentSectionAction", this.selectedConsentSection);
          nprogress.done();
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while adding the consent section");
          nprogress.done();
        }
      );
    },
    deleteOptionalConsentSection(studyId, sectionId, consentId) {
      nprogress.start();
      this.$api.deleteOptionalDatavantConsentSection(studyId, sectionId, consentId).then(
        () => {
          const sectionIndex = _.findIndex(this.consentSections, [
            'sectionId',
            sectionId,
          ]);
          this.consentSections.splice(sectionIndex, 1);
          this.selectedConsentSection = {};
          toastr.success('Consent section deleted successfully');
          this.$store.dispatch(
            'addOptionalConsentSectionAction',
            this.selectedConsentSection,
          );
          nprogress.done();
        },
        error => {
          toastr.error(
            error.body
              ? error.body.message
              : 'Error while adding the consent section',
          );
          nprogress.done();
        },
      );
    },
    setConsentId() {
      if (this.existingConsentData.consentId != "" && this.existingConsentData.opType === "toEdit") {
        this.consentId = this.existingConsentData.consentId;

        //Get disclaimer if any
        this.getDisclaimers();
      }
    },
    setOptionalConsentId() {
      if (
        this.existingConsentData.consentId != "" && // eslint-disable-line
        this.existingConsentData.opType === "toOptionalEdit" // eslint-disable-line
      ) {
        this.consentId = this.existingConsentData.consentId;
        //Get disclaimer if any
        this.getOptionalConsentDatavantDisclaimers();      
      }
    },
    removeConsentFile(consentDocData, index) {
      if (consentDocData.pdfLink && consentDocData.pdfName) {
        swal({
          title: "Are you sure you want to delete?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#b8c7ce",
          cancelButtonColor: "#f16559",
          confirmButtonText: "Cancel",
          cancelButtonText: "Delete"
        }).then(({ dismiss }) => {
          if (dismiss === "cancel") {
            nprogress.start();
            this.$api.deleteConsentDocumentFactV2(this.studyId, this.consentId, consentDocData.language.language_id).then(
              () => {
                this.consentDocData.documentFiles[index].file = "";
                this.consentDocData.documentFiles[index].pdfLink = "";
                this.consentDocData.documentFiles[index].pdfName = "";
                this.consentDocData.documentFiles[index].fileInputRef = null;
                // window.$('#consent_section_doc[type="file"]').val(null);
                nprogress.done();
              },
              error => {
                toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the study details");
                nprogress.done();
              }
            );
          }
        });
      } else {
        this.consentDocData.documentFiles[index].file = "";
        this.consentDocData.documentFiles[index].pdfLink = "";
        this.consentDocData.documentFiles[index].pdfName = "";
        this.consentDocData.documentFiles[index].fileInputRef = null;
      }
    },
    removeOptionalConsentFile(consentDocData, index) {
      if (consentDocData.pdfLink && consentDocData.pdfName) {
        swal({
          title: 'Are you sure you want to delete?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#b8c7ce',
          cancelButtonColor: '#f16559',
          confirmButtonText: 'Cancel',
          cancelButtonText: 'Delete',
        }).then(({ dismiss }) => {
          if (dismiss === 'cancel') {
            nprogress.start();
            this.$api
              .deleteOptionalConsentDocumentFactV2(this.studyId, this.consentId, consentDocData.language.language_id)
              .then(
                () => {
                  this.consentDocData.documentFiles[index].file = '';
                  this.consentDocData.documentFiles[index].pdfLink = '';
                  this.consentDocData.documentFiles[index].pdfName = '';
                  this.consentDocData.documentFiles[index].fileInputRef = null;
                  // window.$('#consent_section_doc[type="file"]').val(null);
                  nprogress.done();
                },
                error => {
                  toastr.error(
                    error.body && error.body.message
                      ? error.body.message
                      : 'Error while getting the study details',
                  );
                  nprogress.done();
                },
              );
          }
        });
      } else {
        this.consentDocData.documentFiles[index].file = '';
        this.consentDocData.documentFiles[index].pdfLink = '';
        this.consentDocData.documentFiles[index].pdfName = '';
        this.consentDocData.documentFiles[index].fileInputRef = null;
      }
    },
    editConsentDocumentScreen(docData) {
      this.tempDocData = _.cloneDeep(docData);
      this.consentDocReadMode = false;
    },
    formatBytes(size) {
      return size / Math.pow(1024, 2);
    },
    saveConsentDocumentScreen(originalConsentDoc, autoSave = false) {
      const consentDoc = { ...originalConsentDoc };
      let error = false;
      if (!autoSave) {
        consentDoc.documentFiles.forEach(doc => {
          if ((doc.file == null || doc.file == "") && (doc.pdfName == null || doc.pdfName == "")) {
            error = true;
            return;
          }
        });
      }
      if (!consentDoc.htmlDocument) {
        if (!autoSave) {
          toastr.error("Please add consent copy.");
        }
        return;
      } else if (error == true) {
        if (!autoSave) {
          toastr.error("Please upload a consent document.");
        }
        return;
      }
      this.onEditorChange({ html: consentDoc.htmlDocument });
      if (this.imageTypeError) {
        if (!autoSave) {
          toastr.error("Uploaded image format not supported. Please upload a PNG file.");
        }
        return;
      }

      //validate Disclaimers
      if (this.disclaimerList.length > 0) {
        for (let i = 0; i < this.disclaimerList.length; i++) {
          if (this.disclaimerList[i].disclaimer.trim() == "") {
            if (!autoSave) {
              toastr.error("Please enter disclaimer content");
            }
            error = true;
            return;
          }
        }
      }

      let oldHtmlDocument = _.cloneDeep(consentDoc.htmlDocument);
      oldHtmlDocument = `<html><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width, initial-scale=1"><link rel="stylesheet" type="text/css" href="editor.css"></head><body class="ql-editor">${oldHtmlDocument}</body></html>`;

      consentDoc.htmlDocument = this.qlVideoUpload.insertDummyUrlToScreen(consentDoc.htmlDocument);

      if (!consentDoc.id) {
        if (!autoSave) {
          if (consentDoc != null && consentDoc != undefined) {
            consentDoc.documentFiles.forEach(doc => {
              if (doc.file && !(this.formatBytes(doc.file.size) <= 10)) {
                error = true;
                toastr.error(doc.file.name + " file size should be less than 10 MB");
              }
            });
          }
        }
        if (error) {
          return;
        }
        // Section with out sectionId === new section
        const fd = new FormData();
        if (consentDoc.htmlDocument && consentDoc.htmlDocument.indexOf("<html><head>") < 0) {
          consentDoc.htmlDocument = `<html><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width, initial-scale=1"><link rel="stylesheet" type="text/css" href="editor.css"></head><body class="ql-editor">${consentDoc.htmlDocument}</body></html>`;
        }
        fd.append("htmlDocument", consentDoc.htmlDocument);
        let documentFilesChanged = false;
        for (let i = 0; i < this.consentDocData.documentFiles.length; i++) {
          if (this.consentDocData.documentFiles[i].file) {
            const fileName = this.consentDocData.documentFiles[i].file ? this.consentDocData.documentFiles[i].pdfName + "=languageId=" + this.consentDocData.documentFiles[i].language.language_id : null;
            if (fileName) {
              documentFilesChanged = true;
              fd.append("file", this.consentDocData.documentFiles[i].file, fileName);
            } else {
              fd.append("file", this.consentDocData.documentFiles[i].file);
            }
          }
        }
        if (!documentFilesChanged) {
          fd.append("file", null);
        }
        nprogress.start();
        this.$api.saveConsentDocumentFactV2(this.studyId, fd, this.consentId).then(
          response => {
            this.consentDocData = response.body;
            this.consentDocData.htmlDocument = oldHtmlDocument;
            this.consentDocData = this.qlVideoUpload.removeScriptAndStylesFromSingleScrn(this.consentDocData, "htmlDocument");
            this.consentDocReadMode = true;
            if (!autoSave) {
              toastr.success("Consent document added successfully.");
            }
            // window.$('#consent_section_doc[type="file"]').val(null);
            this.$emit("exit", true);
            nprogress.done();
            this.editorFocused = null;
          },
          error => {
            if (!autoSave) {
              toastr.error(error.body ? error.body.message : "Error while adding the consent section");
            }
            nprogress.done();
          }
        );
      } else if (consentDoc.id) {
        // Section with sectionId === existing section
        const fd = new FormData();
        if (consentDoc.htmlDocument && consentDoc.htmlDocument.indexOf("<html><head>") < 0) {
          consentDoc.htmlDocument = `<html><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width, initial-scale=1"><link rel="stylesheet" type="text/css" href="editor.css"></head><body class="ql-editor">${consentDoc.htmlDocument}</body></html>`;
        }
        fd.append("htmlDocument", consentDoc.htmlDocument);
        fd.append("file", this.consentDocData.file);
        nprogress.start();
        this.$api.updateConsentDocumentFactV2(this.studyId, consentDoc.id, fd, this.consentId).then(
          response => {
            this.consentDocData = response.body;
            this.consentDocData.htmlDocument = oldHtmlDocument;
            this.consentDocData = this.qlVideoUpload.removeScriptAndStylesFromSingleScrn(this.consentDocData, "htmlDocument");
            this.consentDocReadMode = true;
            if (!autoSave) {
              toastr.success("Consent document updated successfully.");
            }
            this.$emit("exit", true);
            nprogress.done();
            this.editorFocused = null;
          },
          error => {
            this.$store.dispatch("addConsentSectionAction", {});
            if (!autoSave) {
              toastr.error(error.body ? error.body.message : "Error while updating the consent section");
            }
            nprogress.done();
          }
        );
      }

      if (!error) {
        this.addUpdateDisclaimer();
      }
    },
    saveOptionalConsentDocumentScreen(originalConsentDoc, autoSave = false) {
      const consentDoc = { ...originalConsentDoc };
      let error = false;
      if (!autoSave) {
        consentDoc.documentFiles.forEach(doc => {
          if ((doc.file == null || doc.file == "") && (doc.pdfName == null || doc.pdfName == "")) {
            error = true;
            return;
          }
        });
      }
      if (!consentDoc.htmlDocument) {
        if (!autoSave) {
          toastr.error("Please add consent copy.");
        }
        return;
      } else if (error == true) {
        if (!autoSave) {
          toastr.error("Please upload a consent document.");
        }
        return;
      }
      this.onEditorChange({ html: consentDoc.htmlDocument });
      if (this.imageTypeError) {
        if (!autoSave) {
          toastr.error("Uploaded image format not supported. Please upload a PNG file.");
        }
        return;
      }

      //validate Disclaimers
      if (this.disclaimerList.length > 0) {
        for (let i = 0; i < this.disclaimerList.length; i++) {
          if (this.disclaimerList[i].disclaimer.trim() == "") {
            if (!autoSave) {
              toastr.error("Please enter disclaimer content");
            }
            error = true;
            return;
          }
        }
      }

      let oldHtmlDocument = _.cloneDeep(consentDoc.htmlDocument);
      oldHtmlDocument = `<html><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width, initial-scale=1"><link rel="stylesheet" type="text/css" href="editor.css"></head><body class="ql-editor">${oldHtmlDocument}</body></html>`;

      consentDoc.htmlDocument = this.qlVideoUpload.insertDummyUrlToScreen(consentDoc.htmlDocument);

      if (!consentDoc.id) {
        if (!autoSave) {
          if (consentDoc != null && consentDoc != undefined) {
            consentDoc.documentFiles.forEach(doc => {
              if (doc.file && !(this.formatBytes(doc.file.size) <= 10)) {
                error = true;
                toastr.error(doc.file.name + " file size should be less than 10 MB");
              }
            });
          }
        }
        if (error) {
          return;
        }
        // Section with out sectionId === new section
        const fd = new FormData();
        if (consentDoc.htmlDocument && consentDoc.htmlDocument.indexOf("<html><head>") < 0) {
          consentDoc.htmlDocument = `<html><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width, initial-scale=1"><link rel="stylesheet" type="text/css" href="editor.css"></head><body class="ql-editor">${consentDoc.htmlDocument}</body></html>`;
        }
        fd.append("htmlDocument", consentDoc.htmlDocument);
        let documentFilesChanged = false;
        for (let i = 0; i < this.consentDocData.documentFiles.length; i++) {
          if (this.consentDocData.documentFiles[i].file) {
            const fileName = this.consentDocData.documentFiles[i].file ? this.consentDocData.documentFiles[i].pdfName + "=languageId=" + this.consentDocData.documentFiles[i].language.language_id : null;
            if (fileName) {
              documentFilesChanged = true;
              fd.append("file", this.consentDocData.documentFiles[i].file, fileName);
            } else {
              fd.append("file", this.consentDocData.documentFiles[i].file);
            }
          }
        }
        if (!documentFilesChanged) {
          fd.append("file", null);
        }
        nprogress.start();
        this.$api.saveOptionalConsentDocument(this.studyId, fd, this.consentId).then(
          response => {
            this.consentDocData = response.body;
            this.consentDocData.htmlDocument = oldHtmlDocument;
            this.consentDocData = this.qlVideoUpload.removeScriptAndStylesFromSingleScrn(this.consentDocData, "htmlDocument");
            this.consentDocReadMode = true;
            if (!autoSave) {
              toastr.success("Consent document added successfully.");
            }
            // window.$('#consent_section_doc[type="file"]').val(null);
            this.$emit("exit", true);
            nprogress.done();
            this.editorFocused = null;
          },
          error => {
            if (!autoSave) {
              toastr.error(error.body ? error.body.message : "Error while adding the consent section");
            }
            nprogress.done();
          }
        );
      } else if (consentDoc.id) {
        // Section with sectionId === existing section
        const fd = new FormData();
        if (consentDoc.htmlDocument && consentDoc.htmlDocument.indexOf("<html><head>") < 0) {
          consentDoc.htmlDocument = `<html><head><meta charset="utf-8"><meta http-equiv="X-UA-Compatible" content="IE=edge"><meta name="viewport" content="width=device-width, initial-scale=1"><link rel="stylesheet" type="text/css" href="editor.css"></head><body class="ql-editor">${consentDoc.htmlDocument}</body></html>`;
        }
        fd.append("htmlDocument", consentDoc.htmlDocument);
        fd.append("file", this.consentDocData.file);
        nprogress.start();
        this.$api.updateOptionalConsentDocument(this.studyId, consentDoc.id, fd, this.consentId).then(
          response => {
            this.consentDocData = response.body;
            this.consentDocData.htmlDocument = oldHtmlDocument;
            this.consentDocData = this.qlVideoUpload.removeScriptAndStylesFromSingleScrn(this.consentDocData, "htmlDocument");
            this.consentDocReadMode = true;
            if (!autoSave) {
              toastr.success("Consent document updated successfully.");
            }
            this.$emit("exit", true);
            nprogress.done();
            this.editorFocused = null;
          },
          error => {
            this.$store.dispatch("addOptionalConsentSectionAction", {});
            if (!autoSave) {
              toastr.error(error.body ? error.body.message : "Error while updating the consent section");
            }
            nprogress.done();
          }
        );
      }

      if (!error) {
        this.addUpdateOptionalDisclaimer();
      }
    },
    cancelScreen() {
      swal({
        title: "You have not saved your progress. Are you sure you want to leave? Your changes will not be saved. ",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#34537d",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          if (this.consentDocData.id) {
            this.consentDocReadMode = true;
            this.consentDocData = _.cloneDeep(this.tempDocData);
          } else {
            this.consentDocData = { file: "", htmlDocument: "", pdfLink: "" };
            window.$('#consent_section_doc[type="file"]').val(null);
            this.fileSelected = null;
            this.editorFocused = null;
          }
        }
        this.$emit("exit", true);
      });
    },
    onDocFileSelection(event, index, langObj) {
      if (!(event.srcElement || (event.srcElement.files && event.srcElement.files[0] == null))) {
        return true;
      }
      this.consentDocData.documentFiles[index].file = event.srcElement.files[0];
      this.consentDocData.documentFiles[index].pdfName = event.srcElement.files[0].name;
      this.consentDocData.documentFiles[index].pdfLink = null;
      this.consentDocData.documentFiles[index].language = langObj;
      this.consentDocData.documentFiles[index].fileInputRef = event;
      event.target.value = null;
    },
    updateConsent() {
      nprogress.start();
      this.$api.updateConsentName(this.studyId, this.existingConsentData.consentId, this.existingConsentData.consentName).then(
        () => {
          this.innerBoxes.box1 = false;
          this.innerBoxes.box2 = true;
          toastr.success("Consent name updated successfully.");
          nprogress.done();
        },
        error => {
          toastr.error(error.body && error.body.message ? error.body.message : "Error while updating consent name.");
          nprogress.done();
        }
      );
    },
    addConsent(autoSave = false) {
      const that = this;
      if (that.newConsentName === null || that.newConsentName === "" || that.newConsentName === undefined) {
        if (!autoSave) {
          toastr.error("Please add consent name.");
        }
      } else if (that.existingConsentList != null && that.existingConsentList.length > 0) {
        const filterList = that.existingConsentList.filter(x => x.consentName == that.newConsentName);
        if (filterList != null && filterList.length > 0) {
          if (!autoSave) {
            toastr.error("A consent with this name already exists.");
          }
        } else {
          that.addEditConsent(autoSave);
        }
      } else {
        that.addEditConsent(autoSave);
      }
    },
    addEditConsent(autoSave = false) {
      const that = this;
      if (that.consentId != "" && that.consentId != undefined) {
        nprogress.start();
        that.$api.updateConsentName(that.studyId, that.consentId, that.newConsentName).then(
          () => {
            if (that.flagData.educationEnabled) {
              that.innerBoxes.box2 = true;
            } else {
              if (that.flagData.comprehensionEnabled) {
                that.innerBoxes.box3 = true;
              } else {
                if (that.flagData.documentAndSignatureEnabled) {
                  that.innerBoxes.box4 = true;
                } else {
                  that.innerBoxes.box4 = false;
                }
                that.innerBoxes.box2 = false;
                that.innerBoxes.box3 = false;
              }
              that.innerBoxes.box2 = false;
            }
            that.innerBoxes.box1 = true;
            that.$forceUpdate();
            if (!autoSave) {
              toastr.success("Consent name updated successfully.");
            }
            nprogress.done();
          },
          error => {
            toastr.error(error.body && error.body.message ? error.body.message : "Error while updating consent name.");
            nprogress.done();
          }
        );
      } else {
        nprogress.start();
        that.$api.addConsentName(that.studyId, that.newConsentName, that.educationEnabled, that.comprehensionEnabled, that.documentAndSignatureEnabled, that.digitalSignatureEnabled).then(
          response => {
            that.consentDataResp = response.data;
            if (that.flagData.educationEnabled) {
              that.innerBoxes.box2 = true;
            } else {
              if (that.flagData.comprehensionEnabled) {
                that.innerBoxes.box3 = true;
              } else {
                if (that.flagData.documentAndSignatureEnabled) {
                  that.innerBoxes.box4 = true;
                } else {
                  that.innerBoxes.box4 = false;
                }
                that.innerBoxes.box2 = false;
                that.innerBoxes.box3 = false;
              }
              that.innerBoxes.box2 = false;
            }
            that.innerBoxes.box1 = true;
            that.$forceUpdate();
            that.newConsentData.push(response.data);
            that.consentId = response.data.consentId;
            that.newConsentId = response.data.consentId;
            const consentId = response.data.consentId;
            if (consentId != "") {
              that.getConsentDetails(consentId, autoSave);
            }
            // this.existingConsentData.opType = "";
          },
          error => {
            toastr.error(error.body && error.body.message ? error.body.message : "Error while adding consent name.");
            nprogress.done();
          }
        );
      }
    },
    getConsentDetails(consentId, autoSave = false) {
      nprogress.start();
      const self = this;
      this.$api.getCosentDataApi(this.studyId, consentId).then(
        response => {
          this.newConsentData.push(response.data);
          if (response.data.sections != null && response.data.sections != undefined) {
            self.consentSections = response.data.sections;
          }

          if (response.data.quiz != null && response.data.quiz != undefined) {
            self.quizQuestions = self.existingConsentData.quiz.questions;
          }
          // self.innerBoxes.box1 = false;
          // self.innerBoxes.box2 = true;
          if (!autoSave) {
            toastr.success("Consent name added successfully.");
          }
          nprogress.done();
        },
        error => {
          if (!autoSave) {
            toastr.error(error.body && error.body.message ? error.body.message : "Error while adding consent name.");
          }
          nprogress.done();
        }
      );
    },
    addNewEducationScreen() {
      this.educationSection.opType = "toAdd";
      this.selectedConsentSection.opType = "toAdd";
      this.selectedConsentSection.consentId = this.consentId;
      this.$nextTick(() => {
        this.smoothLandingOnScreen();
      });
    },
    smoothLandingOnScreen() {
      const element = document.getElementById("add-consent");
      element.scrollIntoView({
        block: "center",
        inline: "center",
        behavior: "smooth"
      });
    },
    onDragSections(consentId) {
      this.consentSections.forEach((item, index) => {
        this.consentSections[index].sectionNumber = index + 1;
      });
      nprogress.start();
      this.$api.updateConsentSectionsOrderFactV2(this.studyId, consentId, this.consentSections).then(
        () => {
          nprogress.done();
        },
        error => {
          toastr.error(error.body && error.body.message ? error.body.message : "Error while saving the data");
          nprogress.done();
        }
      );
    },
    onDragQuiz(consentId) {
      nprogress.start();
      this.$api.updateConsentQuizOrderFactV2(this.studyId, consentId, this.quizQuestions).then(
        () => {
          nprogress.done();
        },
        error => {
          toastr.error(error.body && error.body.message ? error.body.message : "Error while saving the data");
          nprogress.done();
        }
      );
    },
    async editConsentSection(screen) {
      this.selectedConsentSection = _.cloneDeep(screen);
      this.selectedConsentSection.consentId = this.consentId;
      this.selectedConsentSection.opType = "toEdit";
      this.educationSection.opType = "toEdit";
      await PresignedUrlManager.getRenewedPresignedUrl(this.selectedConsentSection.sectionImage, this.selectedConsentSection, "sectionImage", this);
      this.$store.dispatch("addConsentSectionAction", this.selectedConsentSection);
    },
    async editOptionalConsentSection(screen) {
      this.selectedConsentSection = _.cloneDeep(screen);
      this.selectedConsentSection.consentId = this.consentId;
      this.selectedConsentSection.opType = "toOptionalEdit"; // eslint-disable-line
      this.educationSection.opType = "toOptionalEdit"; // eslint-disable-line
      await PresignedUrlManager.getRenewedPresignedUrl( this.selectedConsentSection.sectionImage, this.selectedConsentSection, "sectionImage", this );
      this.$store.dispatch(
        'addOptionalConsentSectionAction',
        this.selectedConsentSection,
      );
    },
    addNewQuizQuestion() {
      this.addEditQuizQuestion.opType = null;
      this.addEditQuizQuestion.opType = "toAdd";
      this.addEditQuizQuestion.consentId = this.consentId;
      setTimeout(() => {
        window.scrollBy(0, 100);
      }, 500);
    },
    editQuizQuestion(screen) {
      this.addEditQuizQuestion = _.cloneDeep(screen);
      this.addEditQuizQuestion.opType = "toEdit";
      this.addEditQuizQuestion.consentId = this.consentId;
      this.$store.dispatch("addConsentSectionAction", this.addEditQuizQuestion);
    },
    editOptionalQuizQuestion(screen) {
      this.addEditQuizQuestion = _.cloneDeep(screen);
      this.addEditQuizQuestion.opType = "toOptionalEdit"; // eslint-disable-line
      this.addEditQuizQuestion.consentId = this.consentId;
      this.$store.dispatch('addOptionalConsentSectionAction', this.addEditQuizQuestion);
    },
    getStudyDetail() {
      this.$api.getStudyDataFact(this.studyId).then(
        response => {
          this.supportedLanguages = response.body.language;
          this.loadQuestion();
        },
        error => {
          toastr.error(error.body && error.body.message ? error.body.message : "Error while getting the study details");
        }
      );
    },
    getDisclaimers() {
      this.$api.getConsentDisclaimers(this.studyId, this.consentId).then(
        response => {
          this.apiDiscliamerResponse = response.body;
          this.disclaimerList = _.cloneDeep(this.apiDiscliamerResponse);
        },
        error => {
          toastr.error(error.body ? error.body.message : "Error while getting the consent disclaimer");
        }
      );
    },
    getOptionalConsentDatavantDisclaimers(){
      this.$api
        .getOptionalConsentDisclaimers(this.studyId, this.consentId)
        .then(response => {
            this.apiDiscliamerResponse = response.body;
            this.disclaimerList = _.cloneDeep(this.apiDiscliamerResponse);
          },
          error => {
            toastr.error(
              error.body
                ? error.body.message
                : 'Error while getting the consent disclaimer',
            );
          },
        );
    },
    addDisclaimer() {
      dynamicDisclaimerID++;
      const newDisclaimer = {
        disclaimer: "",
        disclaimerId: null,
        status: true,
        dynamicDisclaimerID: dynamicDisclaimerID,
        required: false
      };
      this.disclaimerList.push(newDisclaimer);
      setTimeout(() => {
        window.scrollBy(0, 270);
      }, 500);
    },
    removeDisclaimer(index) {
      swal({
        title: "Are you sure you want to remove this disclaimer?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b8c7ce",
        cancelButtonColor: "#34537d",
        confirmButtonText: "Cancel",
        cancelButtonText: "Yes"
      }).then(({ dismiss }) => {
        if (dismiss === "cancel") {
          this.disclaimerList.splice(index, 1);
        }
      });
    },
    addUpdateDisclaimer() {
      const apiDiscliamerLength = this.apiDiscliamerResponse.length;
      if (apiDiscliamerLength == 0 && this.disclaimerList.length == 0) {
        return;
      }

      //Remove the keys that are not need for api request
      _.map(this.disclaimerList, function(dObject) {
        delete dObject.dynamicDisclaimerID;
      });

      if (!!this.disclaimerList && this.disclaimerList.length != 0) {
        this.disclaimerList.forEach(information => {
          if (!!information.disclaimer && information.disclaimer.includes("&nbsp;")) {
            information.disclaimer = information.disclaimer.replaceAll("&nbsp;", " ");
          }
        });
      }
      const resourceMethod = this.apiDiscliamerResponse.length == 0 ? "addDisclaimers" : "updateDisclaimers";
      this.$api[resourceMethod](this.studyId, this.consentId, this.disclaimerList).then(
        () => {},
        error => {
          toastr.error(error.body && error.body.message ? error.body.message : "Error while disclaimer API request.");
        }
      );
    },
    addUpdateOptionalDisclaimer(){
      let apiDiscliamerLength = this.apiDiscliamerResponse.length;
      if(apiDiscliamerLength == 0 && this.disclaimerList.length == 0){
        return;
      }
      //Remove the keys that are not need for api request
      _.map(this.disclaimerList, function(dObject) {
          delete dObject.dynamicDisclaimerID;
        });
        if (!!this.disclaimerList && this.disclaimerList.length != 0) {
        this.disclaimerList.forEach((information, index) => {
          if(!!information.disclaimer && information.disclaimer.includes("&nbsp;")) {
            information.disclaimer = information.disclaimer.replaceAll("&nbsp;"," ");
          }
        });
      }
      let resourceMethod = this.apiDiscliamerResponse.length == 0 ? "addOptionalDisclaimers" : "updateOptionalDisclaimers";
      this.$api[resourceMethod](this.studyId, this.consentId, this.disclaimerList).then(
          response => {},
          error => {
            toastr.error(
              error.body && error.body.message
                ? error.body.message
                : "Error while disclaimer API request."
            );
          }
        );
    },
    saveEconsentFlag(field) {
      nprogress.start();
      const self = this;

      if (this.options.opType == "toAdd") {
        this.flagData.consentId = this.consentDataResp.consentId;
        this.flagData.consentName = this.consentDataResp.consentName;
      }
      if (field == "educationEnabled") {
        self.innerBoxes.box2 = false;
        if (!this.flagData.educationEnabled) {
          this.flagData.comprehensionEnabled = false;
        }
      }

      if (field == "documentAndSignatureEnabled") {
        if (this.flagData.documentAndSignatureEnabled == false) {
          this.flagData.digitalSignatureEnabled = false;
          this.$forceUpdate();
        }
      }
      this.$api.updateConsentSubModuleValue(this.studyId, this.flagData).then(
        () => {
          nprogress.done();
          if (field == "educationEnabled") {
            self.innerBoxes.box2 = false;
            if (!self.flagData.educationEnabled) {
              self.innerBoxes.box3 = false;
            }
          }
          if (field == "comprehensionEnabled") {
            self.innerBoxes.box3 = false;
          }
          if (field == "documentAndSignatureEnabled") {
            self.innerBoxes.box4 = false;
          }
          self.$forceUpdate();
        },
        error => {
          nprogress.done();
          this.$toastr.error(error.body && error.body.message ? error.body.message : "Error while saving eConsent flags.");
        }
      );
    },
    onChangeFlag(flag, field) {
      if (this.options.opType == "toAdd") {
        this.$emit("consentDataSend", this.flagData.comprehensionEnabled, this.flagData.documentAndSignatureEnabled, this.flagData.educationEnabled);

        if (this.consentDataResp && this.consentDataResp.consentId) {
          this.saveEconsentFlag(field);
        } else {
          toastr.warning("Please save consent name first.");
          if (field == "educationEnabled") {
            this.flagData.educationEnabled = !flag;
          }
          if (field == "comprehensionEnabled") {
            this.flagData.comprehensionEnabled = !flag;
          }
          if (field == "documentAndSignatureEnabled") {
            this.flagData.documentAndSignatureEnabled = !flag;
          }
          if (field == "digitalSignatureEnabled") {
            this.flagData.digitalSignatureEnabled = !flag;
          }
          return;
        }
      }

      if (this.options.opType == "toEdit") {
        this.$emit("consentDataSend", this.flagData.comprehensionEnabled, this.flagData.documentAndSignatureEnabled, this.flagData.educationEnabled);

        if (!flag) {
          swal({
            title: "You are about to turn off this section. Any configuration you may have will be lost. Are you sure you want to delete this configuration?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#b8c7ce",
            cancelButtonColor: "#f16559",
            confirmButtonText: "Cancel",
            cancelButtonText: "Yes"
          }).then(({ dismiss }) => {
            if (dismiss === "cancel") {
              this.saveEconsentFlag(field);
            } else {
              if (field == "educationEnabled") {
                this.flagData.educationEnabled = !flag;
              }
              if (field == "comprehensionEnabled") {
                this.flagData.comprehensionEnabled = !flag;
              }
              if (field == "documentAndSignatureEnabled") {
                this.flagData.documentAndSignatureEnabled = !flag;
              }
              if (field == "digitalSignatureEnabled") {
                this.flagData.digitalSignatureEnabled = !flag;
              }
              this.$forceUpdate(field);
            }
          });
        } else {
          this.saveEconsentFlag();
        }
      }
      if(this.options.opType == 'toOptionalEdit'){
        this.$emit('consentDataSend', this.flagData.comprehensionEnabled, this.flagData.documentAndSignatureEnabled, this.flagData.educationEnabled);
        if(!flag){
        swal({
            title: 'You are about to turn off this section. Any configuration you may have will be lost. Are you sure you want to delete this configuration?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#b8c7ce',
            cancelButtonColor: '#f16559',
            confirmButtonText: 'Cancel',
            cancelButtonText: 'Yes',
          }).then(({ dismiss }) => {
            if (dismiss === 'cancel') {
              this.saveOptionalEconsentFlag(field);
            }else{
              if(field == 'educationEnabled'){
                this.flagData.educationEnabled = !flag;
              }
              if(field == 'comprehensionEnabled'){
                this.flagData.comprehensionEnabled = !flag;
              }
              if(field == 'documentAndSignatureEnabled'){
                this.flagData.documentAndSignatureEnabled = !flag;
              }
              if(field == 'digitalSignatureEnabled'){
                this.flagData.digitalSignatureEnabled = !flag;
              }
              this.$forceUpdate(field);
            }
          });
        }else{
          this.saveOptionalEconsentFlag();
        }
      }
    },
    saveOptionalEconsentFlag(field) {
      nprogress.start();
      let self = this;
      if(this.options.opType == 'toOptionalEdit'){
          this.flagData.consentId = this.existingConsentData.consentId;
          this.flagData.consentName = this.existingConsentData.consentName;
      }
      if(field == 'educationEnabled'){
        self.innerBoxes.box2 = false;
        if(!this.flagData.educationEnabled){
          this.flagData.comprehensionEnabled = false;
        }
      }
      if(field == 'documentAndSignatureEnabled'){
        if(this.flagData.documentAndSignatureEnabled == false){
          this.flagData.digitalSignatureEnabled = false;
          this.$forceUpdate();
        }
      }
      this.$api.updateOptionalConsentSubModuleValue(this.studyId, this.flagData).then(response => {
        nprogress.done();
         if(field == 'educationEnabled'){
            self.innerBoxes.box2 = false;
            if(!self.flagData.educationEnabled){
              self.innerBoxes.box3 = false;
            }
          }
          if(field == 'comprehensionEnabled'){
            self.innerBoxes.box3 = false;
          }
          if(field == 'documentAndSignatureEnabled'){
            self.innerBoxes.box4 = false;
          }
          self.$forceUpdate();
      },
      error => {
          nprogress.done();
          this.$toastr.error(
            error.body && error.body.message
              ? error.body.message
              : "Error while saving eConsent flags."
          );
        });
    },
    onEditorFocus(quill) {
      this.editorFocused = quill;
    },
    customVideoButtonHandler(val) {
      if (val && this.editorFocused) {
        this.$refs.videoUploadModal.show();
      }
    },
    insertVideoInEditor(data) {
      const length = this.editorFocused.getSelection() ? this.editorFocused.getSelection().index : this.editorFocused.selection.savedRange.index;
      this.editorFocused.insertEmbed(length, "uploadedVideo", data);
      this.editorFocused.setSelection(length + 1);
    },
    initLocalVideoUploadButton() {
      // initialize "custom upload" button style
      this.$nextTick(() => {
        const videoButton = document.querySelector(".ql-localVideoUpload"); // "QL -" is the prefix automatically added by the plug-in
        if (videoButton) {
          //Add a style and initialize the style of the icon with fontawesome
          videoButton.classList.add("fa");
          videoButton.classList.add("fa-video-camera");
        }
      });
    },
    onEditorReady(editor) {
      this.editorFocused = editor;
    },
    addVideoData(data) {
      if (data && data.videoId) {
        this.options.participantVideos[data.videoId] = data.url;
      }
    },
    autoSaveMultiConsent() {
      if (this.innerBoxes.box1) {
        if (this.existingConsentData.opType === "toEdit") {
          this.nextChangeConsentName(true);
        } else {
          this.addConsent(true);
        }
      }
      if (this.innerBoxes.box4) {
        this.saveConsentDocumentScreen(this.consentDocData, true);
      }
    },
    autoSaveOptionalConsent(){
      if(this.innerBoxes.box1)  {
        if(this.existingConsentData.opType==='toOptionalEdit') {
          this.optionalEditConsent(true)
        }        
      if(this.innerBoxes.box4) {
        this.saveOptionalConsentDocumentScreen(this.consentDocData, true);
       }
    }
  },
    startAutoSave() {
      this.autoSaveTimer = setInterval(() => {
        if(this.existingConsentData.opType==='toOptionalEdit') {
          this.autoSaveOptionalConsent();
        }
        else{
          this.autoSaveMultiConsent();
        }
      }, this.autoSaveElementTimeout);
    },
    stopAutoSave() {
      clearInterval(this.autoSaveTimer);
    },
    resetAutoSave() {
      this.$emit("autoSaveReset");
      this.stopAutoSave();
      this.startAutoSave();
    }
  },
  beforeDestroy() {
    if(this.existingConsentData.optype==='toOptionalEdit'){
      this.autoSaveOptionalConsent();
    }
    else{
      this.autoSaveMultiConsent();
    }
    this.stopAutoSave();
  },
  components: {
    addEditEducation,
    addEditQuiz,
    draggable,
    videoUploadModal,
    quillEditor
  }
};
</script>

<style scoped lang="scss">
.apply-float {
  float: left;
}
.lang-text {
  font-family: Lato-Regular;
  font-weight: bold;
  letter-spacing: normal;
  color: #4a4a4a;
}
.clear-float {
  clear: both;
}
.heading-box {
  margin-left: 50px;
  margin-top: 43px;

  .main-heading {
    font-family: Lato-Regular;
    font-size: 22px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.21;
    letter-spacing: normal;
    color: #2d3752;
  }

  .sub-heading {
    font-family: Lato-Regular;
    font-size: 15px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.29;
    letter-spacing: normal;
    color: #4a4a4a;
    margin-top: 4px;
  }
}

.child-container {
  margin-left: 50px;
  margin-right: 50px;
  margin-bottom: 50px;
  margin-top: 20px;
  border-radius: 4px;
  border: solid 1px #e4e8eb;
  background-color: #ffffff;
  padding: 20px 20px;

  .box {
    .box-heading {
      font-family: Lato-Regular;
      font-size: 17px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.4;
      letter-spacing: normal;
      color: #4a4a4a;
      cursor: pointer;

      img {
        margin-right: 10px;
      }
    }
    .active {
      color: #1e8fe1;
    }

    .inner-box {
      margin-left: 35px;
    }
    .inactive {
      opacity: 0.5;
      pointer-events: none;
    }
    .input-field {
      width: 250px;
      height: 40px;
      border-radius: 3px;
      border: solid 1px #e4e8eb;
      background-color: #ffffff;
      font-family: Lato-Regular;
      font-size: 15px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      color: #9b9b9b;
      padding-left: 11.5px;
      margin-top: 10px;
    }

    .continue-btn1 {
      width: 100px;
      height: 36px;
      border-radius: 4px;
      border: solid 2px #ffffff;
      display: block;
      margin-top: 15px;
      font-family: Lato-Regular;
      font-size: 15px;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      text-align: center;
      color: #ffffff;
      background: #1e8fe1;
      cursor: pointer;
    }
  }

  .box-divider {
    width: 1000px;
    height: 1px;
    background-color: #e4e8eb;
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .add-another-education-screen-btn {
    width: 150px;
    height: 30px;
    border-radius: 3px;
    background-color: #fff;
    font-family: Lato-Regular;
    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #1e8fe1;
    border: 1px solid #1e8fe1;
    margin-top: 20px;
    cursor: pointer;
  }

  .box2-content {
    font-family: Lato-Regular;
    font-size: 15px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: #4a4a4a;
    margin: 7px 0px;
  }

  .box2-draggable-education {
    height: 70%;
    border-radius: 3px;
    border: solid 1px #e4e8eb;
    background-color: #f5f6f7;
    margin-top: 10px;
    margin-right: 20px;

    span {
      display: block;
      float: left;
      width: auto;

      img {
        padding: 25px 10px;
      }
    }

    .content {
      padding: 15px 0px;
      display: inline-block;
      float: left;
      width: 80%;

      .heading {
        font-family: Lato-Regular;
        font-size: 15px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.33;
        letter-spacing: normal;
        color: #4a4a4a;
        word-break: break-word !important;
      }

      .text {
        font-family: Lato-Regular;
        font-size: 15px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.33;
        letter-spacing: normal;
        color: #4a4a4a;
        word-break: break-word !important;
      }
    }

    .btn {
      float: right;
      padding: 20px;

      button {
        width: 70px;
        height: 30px;
        border-radius: 3px;
        background-color: #f5f6f7;
        font-family: Lato-Regular;
        font-size: 13px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #1e8fe1;
        border: solid 1px #1e8fe1;
        cursor: pointer;
      }
    }

    .clearfix {
      clear: both;
    }

    .box3-content {
      font-family: Lato;
      font-size: 15px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      color: #4a4a4a;
      margin-top: 6px;
    }
  }

  .add-a-question-btn {
    width: 150px;
    height: 30px;
    border-radius: 3px;
    background-color: #fff;
    font-family: Lato-Regular;
    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #1e8fe1;
    border: solid 1px #1e8fe1;
    margin-top: 20px;
    cursor: pointer;
  }

  .continue-btn3 {
    width: 100px;
    height: 36px;
    border-radius: 4px;
    border: solid 2px #ffffff;
    display: block;
    margin-top: 15px;
    font-family: Lato-Regular;
    font-size: 15px;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    background: #1e8fe1;
    margin-top: 30px;
    cursor: pointer;
  }
}

.document-section {
  .btns {
    float: right;

    .cancel-btn {
      width: 100px;
      height: 36px;
      border-radius: 3px;
      background-color: #fff;
      font-family: Lato-Regular;
      font-size: 15px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      text-align: center;
      color: #1e8fe1;
      border: 0;
      cursor: pointer;
      margin-right: 10px;
    }

    .save-btn {
      width: 100px;
      height: 36px;
      border-radius: 3px;
      background-color: #1e8fe1;
      font-family: Lato-Regular;
      font-size: 15px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      text-align: center;
      color: #fff;
      border: 1px solid #1e8fe1;
      cursor: pointer;
    }
  }

  .heading1 {
    font-family: Lato-Regular;
    font-size: 17px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.29;
    letter-spacing: normal;
    color: #4a4a4a;
    margin-top: 6px;
  }

  .heading2 {
    margin-top: 30px;
    font-family: Lato-Regular;
    font-size: 17px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.29;
    letter-spacing: normal;
    color: #4a4a4a;
  }

  .heading3 {
    margin-top: 30px;
    font-family: Lato-Regular;
    font-size: 17px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.29;
    letter-spacing: normal;
    color: #4a4a4a;
  }

  .text1 {
    font-family: Lato-Regular;
    font-size: 15px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: #4a4a4a;
  }

  .upload-btn {
    margin-top: 10px;

    .upload-btn {
      width: 100px;
      height: 30px;
      border-radius: 3px;
      background-color: #fff;
      font-family: Lato-Regular;
      font-size: 13px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #1e8fe1;
      border: solid 1px #1e8fe1;
      cursor: pointer;
    }
  }

  .input1 {
    margin-top: 10px;

    input {
      width: 450px;
      height: 40px;
      border-radius: 3px;
      border: solid 1px #e4e8eb;
      background-color: #ffffff;
      padding-left: 11px;
    }

    input:placeholder {
      font-family: Lato-Regular;
      font-size: 15px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      color: #9b9b9b;
    }
  }

  .input2 {
    margin-top: 10px;

    textarea {
      width: 970px;
      height: 100px;
      border-radius: 3px;
      border: solid 1px #e4e8eb;
      background-color: #ffffff;
      padding-left: 10px;
      padding-top: 10px;
    }

    textarea:placeholder {
      font-family: Lato;
      font-size: 15px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      color: #9b9b9b;
    }
  }
}
.bottom-section {
  margin-top: 50px;

  .left-block {
    clear: both;
    float: left;
  }

  .right-block {
    float: right;

    .save-btn {
      width: 100px;
      height: 36px;
      border-radius: 4px;
      border: solid 2px #1e8fe1;
      font-family: Lato-Regular;
      font-size: 15px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.33;
      letter-spacing: normal;
      text-align: center;
      background: #1e8fe1;
      color: #ffffff;
    }
  }

  .clearfix {
    clear: both;
  }
}

.file-upload {
  position: relative;
  overflow: hidden;
  border: none;
  width: 80px;
  height: 30px;
  border-radius: 3px;
  padding: 5px 10px;
  display: inline;
  background-color: #fff;
  width: 100px;
  height: 36px;
  border-radius: 4px;
  border: solid 1px #1e8fe1;
  font-family: Lato-Regular;
  font-size: 13px;
  /* font-weight: bold; */
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  background: #fff;
  color: #1e8fe1;
}

.question-panel {
  .question-section {
    height: auto;
    border-radius: 3px;
    border: solid 1px #e4e8eb;
    background: #e4e8eb;
    padding: 15px;
    margin-top: 10px;
  }

  .heading {
    font-family: Lato-Regular;
    font-size: 15px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: #4a4a4a;
  }

  .description {
    font-family: Lato-Regular;
    font-size: 15px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: #4a4a4a;
  }

  .edit-btn {
    width: 150px;
    height: 30px;
    border-radius: 3px;
    background-color: #fff;
    font-family: Lato-Regular;
    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #1e8fe1;
    border: 1px solid #1e8fe1;
    margin-top: 20px;
    cursor: pointer;
  }
}

.box2-continue-btn {
  width: 100px;
  height: 36px;
  border-radius: 4px;
  border: solid 2px #ffffff;
  display: block;
  margin-top: 15px;
  font-family: Lato-Regular;
  font-size: 15px;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  background: #1e8fe1;
  cursor: pointer;
}

.disabled_continue_btn {
  opacity: 0.5;
}

.delete-btn {
  cursor: pointer;
}

.back-button {
  margin: 0;
  padding: 0;
  margin-left: 50px;
  margin-top: -30px;
}

button:hover {
  opacity: 0.5;
}

.disclaimer-section {
  .heading3 {
    margin-top: 20px;
  }
  .form-group {
    position: relative;
    label {
      color: #4a4a4a;
      margin-bottom: 0.125rem;
    }
    textarea {
      border-radius: 3px;
      border: solid 1px #e4e8eb;
      width: 91%;
    }
    .remove {
      color: #f66855;
      position: absolute;
      top: 50%;
      left: 93%;
      cursor: pointer;
    }
    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .disclaimer-btn {
    border-radius: 3px;
    background-color: #fff;
    font-family: Lato-Regular;
    font-size: 13px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #1e8fe1;
    border: solid 1px #1e8fe1;
    margin-top: 20px;
    cursor: pointer;
    padding: 7px 15px;
  }

  .list-enter-active,
  .list-leave-active {
    transition: opacity 0.5s;
  }
  .list-enter, .list-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
}
.radio-style {
  top: 5px;
  text-align: center;
}
.disclaimer-radio {
  transform: scale(1.5);
}
.disclaimer-remove {
  color: #f66855;
  position: absolute;
  top: 40%;
  left: 102%;
  cursor: pointer;
}
.error-style {
  font-size: 12px;
  line-height: 1.2 !important;
  color: #ff4848;
  padding-bottom: 5px;
  padding-left: 0;
}
.switch {
  position: relative;
  display: inline-block;
  width: 32px;
  height: 20px;
  margin-left: 6px;
  margin-right: 6px;
}
.switch input {
  display: none;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: -1px;
  left: -2px;
  right: -3px;
  bottom: -1px;
  border: 2px solid #ccc;
}
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 1px;
  background-color: #ccc;
}
input:checked + .slider {
  border: 2px solid #48bf7a;
}
input:checked + .slider:before {
  content: "";
  background-color: #48bf7a;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
input:checked + .slider:before {
  position: absolute;
  color: #2ecc71;
  text-align: center;
  font-size: 20px;
  -webkit-transform: translateX(14px);
  -ms-transform: translateX(14px);
  transform: translateX(14px);
}
/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.checkbox {
  width: 12px;
  height: 12px;
}
.on {
  opacity: 0.7;
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
}
.off {
  opacity: 0.7;
  font-family: Roboto-Regular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #666669;
}
.t-switch {
  display: block;
}
.on-off {
  text-align: center;
  display: flex;
}
.disable-consent {
  opacity: 0.5;
  // pointer-events: none;
}
.disabled-icon {
  pointer-events: none;
}
.box-divider-1 {
  width: 960px;
  height: 1px;
  background-color: #e4e8eb;
  margin-top: 15px;
  margin-bottom: 15px;
}
.Digital-signature {
  width: 110px;
  height: 20px;
  font-family: Lato-Regular;
  font-size: 15px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #4a4a4a;
}
.on-off-1 {
  text-align: center;
  display: flex;
  margin-left: 95px;
}
</style>